import React, { useState, useEffect, useRef } from 'react';
import {
  Typography,
  Card,
  Table,
  Dropdown,
  Button,
  Space,
  Input,
  Select,
  Modal,
  Form,
  DatePicker,
  Divider,
  InputNumber,
  message,
  Popconfirm,
  Tag,
  Tooltip,
  Row,
  Col,
  Statistic,
  Drawer,
  Descriptions,
  Tabs,
  Empty,
  Spin,
  Badge,
  List,
  FloatButton,
  Grid,
  Alert,
  Switch,
  Radio,
  Collapse
} from 'antd';
import {
  PlusOutlined,
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  FileTextOutlined,
  DollarOutlined,
  CalendarOutlined,
  UserOutlined,
  PrinterOutlined,
  PayCircleOutlined,
  MoneyCollectOutlined,
  FilterOutlined,
  ScanOutlined,
  BarcodeOutlined,
  BookOutlined,
  SendOutlined,
  GiftOutlined,
  MoreOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
  getReceipts,
  getReceiptById,
  createReceipt,
  updateReceipt,
  deleteReceipt,
  payReceipt,
  previewReceiptPosting,
  postReceiptToAccounting,
  getSalesStats,
  getReceiptStatusLabel,
  getReceiptStatusColor
} from '../../services/receiptService';
import { createContact, getCustomersForDropdown } from '../../services/contactService';
import { getProducts, getProductByBarcode } from '../../services/productService';
import { generateReceiptPDF } from '../../services/receiptPdfService';
import {
  getCompanySettings,
  updateCompanySettings,
  updateSignatureLayout,
  uploadCompanyLogo,
  deleteCompanyLogo,
  getLogoUrl
} from '../../services/settingsService';
import { generateReceiptsTablePDF } from '../../services/receiptTablePdfService';
import { useAuth } from '../../contexts/AuthContext'
import { User2Icon } from 'lucide-react';
import { confirmReceiptProduction, cancelReceiptProduction } from '../../services/materialService';
import AccountingPostingPreviewModal from '../../components/AccountingPostingPreviewModal';
import DocumentPresetQuickSelect from '../../components/DocumentPresetQuickSelect';
import SignatureLayoutControls from '../../components/SignatureLayoutControls';
import MobilePdfPreview from './MobilePdfPreview';
import { getCompanySignatureLayout, SIGNATURE_LAYOUT_DEFAULTS } from '../../utils/signatureLayout';
import inventoryService from '../../services/inventoryService';
import './ReceiptsPage.mobile.css';
import './ReceiptsPrintModal.css';

const { Title, Text } = Typography
const { TextArea } = Input;
const { Option } = Select;
const { TabPane } = Tabs;
const { useBreakpoint } = Grid;

const RECEIPT_PRINT_OPTIONS_KEY = 'RECEIPT_PRINT_OPTIONS';
const RECEIPT_PRINT_OPTIONS_DEFAULTS = {
  collector_mode: 'current_user',
  collector_custom_name: '',
  salesperson_mode: 'current_user',
  salesperson_custom_name: '',
  show_signature: true,
  show_stamp: true,
  delivery_invoice_font_scale: 1,
  show_document_date: true,
  delivery_invoice_show_signature: true
};

const loadReceiptPrintOptions = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(RECEIPT_PRINT_OPTIONS_KEY) || '{}');
    return {
      ...RECEIPT_PRINT_OPTIONS_DEFAULTS,
      ...stored,
      show_document_date: typeof stored.show_document_date === 'boolean'
        ? stored.show_document_date
        : stored.delivery_invoice_show_date !== false
    };
  } catch {
    return { ...RECEIPT_PRINT_OPTIONS_DEFAULTS };
  }
};

const ReceiptsPage = () => {

  const { user, hasRole, hasPermission } = useAuth()
  const isSuperAdmin = hasRole('SUPER_ADMIN')
  const [printType, setPrintType] = useState("full");
  const [receipts, setReceipts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [detailDrawerVisible, setDetailDrawerVisible] = useState(false);
  const [editingReceipt, setEditingReceipt] = useState(null);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [paymentReceipt, setPaymentReceipt] = useState(null);
  const [postingReceipt, setPostingReceipt] = useState(null);
  const [fulfillmentOpen, setFulfillmentOpen] = useState(false);
  const [fulfillmentLoading, setFulfillmentLoading] = useState(false);
  const [fulfillmentData, setFulfillmentData] = useState(null);
  const [fulfillmentSerials, setFulfillmentSerials] = useState({});
  const [fulfillmentReason, setFulfillmentReason] = useState('');
  const [fulfilledDate, setFulfilledDate] = useState(dayjs());
  const [salesStats, setSalesStats] = useState({
    total_sales: 0,
    total_receipts: 0,
    paid_receipts: 0,
    outstanding_amount: 0
  });
  const [form] = Form.useForm();
  const [paymentForm] = Form.useForm();
  const [customerForm] = Form.useForm();
  const [customerModalVisible, setCustomerModalVisible] = useState(false);
  const [customerSaving, setCustomerSaving] = useState(false);
  const canCreateCustomer = hasPermission('contacts', 'create');

  // Responsive state
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [mobileFiltersVisible, setMobileFiltersVisible] = useState(false);



  //สำหรับ modal แสดง pdf
  const [pdfModalVisible, setPdfModalVisible] = useState(false);
  const [pdfDataUrl, setPdfDataUrl] = useState('');
  const [pdfObjectUrl, setPdfObjectUrl] = useState('');
  const [mobilePrintTab, setMobilePrintTab] = useState('preview');
  const [pdfPreviewKind, setPdfPreviewKind] = useState('receipt');
  const [pdfFileName, setPdfFileName] = useState('');
  const [pdfPreviewReceipt, setPdfPreviewReceipt] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [signatureLayout, setSignatureLayout] = useState({ ...SIGNATURE_LAYOUT_DEFAULTS.receipt });
  const [signatureLayoutSaving, setSignatureLayoutSaving] = useState(false);
  const [receiptPrintOptions, setReceiptPrintOptions] = useState(loadReceiptPrintOptions);

  // ข้อมูลบริษัท
  const [company, setCompany] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);

  // Pagination and filters
  const [initialMonthRange] = useState(() => {
    const today = dayjs();
    return [today.startOf('month'), today.endOf('month')];
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({
    search: '',
    status: '',
    contact_id: '',
    start_date: initialMonthRange[0].format('YYYY-MM-DD'),
    end_date: initialMonthRange[1].format('YYYY-MM-DD'),
  });
  const [statusCounts, setStatusCounts] = useState([]);

  // Barcode states
  const [barcodeMode, setBarcodeMode] = useState(false);
  const [barcodeInput, setBarcodeInput] = useState('');
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const barcodeInputRef = useRef(null);

  // Date Filter State
  const [selectedDateRange, setSelectedDateRange] = useState(initialMonthRange);
  const [selectedQuickFilter, setSelectedQuickFilter] = useState('this_month');
  const salesPeriodLabels = {
    all: 'ทั้งหมด',
    this_month: 'เดือนนี้',
    last_month: 'เดือนที่แล้ว',
    last_3_months: 'รอบ 3 เดือน',
    last_6_months: 'รอบ 6 เดือน',
    this_year: 'ปีนี้',
    last_year: 'ปีที่แล้ว'
  };
  const salesPeriodLabel = selectedQuickFilter === 'custom'
    ? (filters.start_date || filters.end_date ? 'ช่วงวันที่เลือก' : 'ทั้งหมด')
    : (salesPeriodLabels[selectedQuickFilter] || 'ทั้งหมด');
  const { RangePicker } = DatePicker;

  // Date filter handlers
  const handleQuickDateFilter = (filterType) => {
    setSelectedQuickFilter(filterType);
    const today = dayjs();
    let startDate, endDate;

    switch (filterType) {
      case 'this_month':
        startDate = today.clone().startOf('month');
        endDate = today.clone().endOf('month');
        break;
      case 'last_month':
        startDate = today.clone().subtract(1, 'month').startOf('month');
        endDate = today.clone().subtract(1, 'month').endOf('month');
        break;
      case 'last_3_months':
        startDate = today.clone().subtract(3, 'months').startOf('month');
        endDate = today.clone().endOf('month');
        break;
      case 'last_6_months':
        startDate = today.clone().subtract(6, 'months').startOf('month');
        endDate = today.clone().endOf('month');
        break;
      case 'this_year':
        startDate = today.clone().startOf('year');
        endDate = today.clone().endOf('year');
        break;
      case 'last_year':
        startDate = today.clone().subtract(1, 'year').startOf('year');
        endDate = today.clone().subtract(1, 'year').endOf('year');
        break;
      default:
        startDate = null;
        endDate = null;
    }

    setSelectedDateRange([startDate, endDate]);

    // Update filters
    setFilters(prev => ({
      ...prev,
      start_date: startDate ? startDate.format('YYYY-MM-DD') : '',
      end_date: endDate ? endDate.format('YYYY-MM-DD') : ''
    }));
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const handleDateRangeChange = (dates) => {
    const dateRange = dates || [null, null];
    setSelectedDateRange(dateRange);
    setSelectedQuickFilter('custom');

    setFilters(prev => ({
      ...prev,
      start_date: dateRange[0] ? dateRange[0].format('YYYY-MM-DD') : '',
      end_date: dateRange[1] ? dateRange[1].format('YYYY-MM-DD') : ''
    }));
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const clearDateFilter = () => {
    const dateRange = [null, null];
    setSelectedDateRange(dateRange);
    setSelectedQuickFilter('all');

    setFilters(prev => ({
      ...prev,
      start_date: '',
      end_date: ''
    }));
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  // Status options
  const statusOptions = [
    { value: 'invoice', label: 'ใบแจ้งหนี้', color: 'processing' },
    { value: 'paid', label: 'ชำระแล้ว', color: 'success' },
    { value: 'partial', label: 'ชำระบางส่วน', color: 'warning' },
    { value: 'overdue', label: 'เกินกำหนด', color: 'error' },
    { value: 'cancelled', label: 'ยกเลิก', color: 'default' },
  ];

  // Payment methods
  const paymentMethods = [
    'เงินสด',
    'โอนผ่านธนาคาร',
    'เช็ค',
    'บัตรเครดิต',
    'บัตรเดบิต',
    'อื่นๆ'
  ];

  // VAT modes
  const vatModeOptions = [
    { value: 'no_tax', label: 'ไม่มีภาษี', color: 'green' },
    { value: 'exclude', label: 'แยกภาษี (VAT EXCLUDE)', color: 'blue' },
    { value: 'include', label: 'รวมภาษี (VAT INCLUDE)', color: 'green' }
  ];

  // โหลดค่าจาก localStorage ครั้งแรกตอนเปิด Modal
  useEffect(() => {
    if (modalVisible) {
      const savedType = localStorage.getItem('PRINT_TYPE');
      if (savedType) {
        setPrintType(savedType);
      }
    }
  }, [modalVisible]);

  const handleDownloadPdf = () => {
    if (!pdfDataUrl) return;

    const link = document.createElement('a');
    link.href = pdfObjectUrl || pdfDataUrl;
    link.download = pdfFileName || 'receipt.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenPdf = () => {
    if (pdfObjectUrl || pdfDataUrl) window.open(pdfObjectUrl || pdfDataUrl, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    if (!pdfDataUrl) {
      setPdfObjectUrl('');
      return undefined;
    }
    try {
      const base64 = pdfDataUrl.split(',')[1];
      const bytes = Uint8Array.from(atob(base64), character => character.charCodeAt(0));
      const objectUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
      setPdfObjectUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('PDF object URL error:', error);
      setPdfObjectUrl('');
      return undefined;
    }
  }, [pdfDataUrl]);

  const updateReceiptPrintOptions = (changes) => {
    setReceiptPrintOptions(current => {
      const next = { ...current, ...changes };
      try {
        localStorage.setItem(RECEIPT_PRINT_OPTIONS_KEY, JSON.stringify(next));
      } catch {
        // The preview still works when browser storage is unavailable.
      }
      return next;
    });
  };

  useEffect(() => {
    if (!pdfModalVisible || !pdfPreviewReceipt) {
      return;
    }

    let isActive = true;

    const refreshPdfPreview = async () => {
      setPdfLoading(true);
      setPdfDataUrl('');

      try {
        const currentUserName = user?.name || user?.email || '';
        const printOptions = {
          collector_name: receiptPrintOptions.collector_mode === 'current_user'
            ? currentUserName
            : receiptPrintOptions.collector_custom_name.trim(),
          salesperson_name: receiptPrintOptions.salesperson_mode === 'current_user'
            ? currentUserName
            : receiptPrintOptions.salesperson_custom_name.trim(),
          show_signature: printType === 'delivery_invoice'
            ? receiptPrintOptions.delivery_invoice_show_signature !== false
            : receiptPrintOptions.show_signature,
          show_stamp: receiptPrintOptions.show_stamp,
          delivery_invoice_font_scale: receiptPrintOptions.delivery_invoice_font_scale,
          show_document_date: receiptPrintOptions.show_document_date
        };
        const pdfResult = await generateReceiptPDF(
          pdfPreviewReceipt,
          company || {},
          printType,
          signatureLayout,
          printOptions
        );

        if (isActive) {
          setPdfDataUrl(pdfResult.dataUrl);
          setPdfFileName(pdfResult.fileName);
        }
      } catch (error) {
        console.error('PDF preview refresh error:', error);

        if (isActive) {
          message.error('เกิดข้อผิดพลาดในการอัปเดตตัวอย่าง PDF: ' + error.message);
        }
      } finally {
        if (isActive) {
          setPdfLoading(false);
        }
      }
    };

    const previewTimer = window.setTimeout(refreshPdfPreview, 300);

    return () => {
      isActive = false;
      window.clearTimeout(previewTimer);
    };
  }, [pdfModalVisible, pdfPreviewReceipt, company, printType, signatureLayout, receiptPrintOptions, user]);

  useEffect(() => {
    if (company) setSignatureLayout(getCompanySignatureLayout(company, 'receipt'));
  }, [company]);

  const handleSaveSignatureLayout = async () => {
    setSignatureLayoutSaving(true);
    try {
      const response = await updateSignatureLayout('receipt', signatureLayout);
      const layouts = response.data?.data?.signature_layout;
      if (layouts) setCompany(current => ({ ...(current || {}), signature_layout: layouts }));
      message.success('บันทึกตำแหน่งลายเซ็นสำหรับใบเสร็จ/ใบแจ้งหนี้แล้ว');
    } catch (error) {
      message.error(error.response?.data?.message || 'ไม่สามารถบันทึกตำแหน่งลายเซ็นได้');
    } finally {
      setSignatureLayoutSaving(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await getCompanySettings();
      if (response.data.success) {
        const data = response.data.data;
        setCompany(data);
        form.setFieldsValue(data);
        setLogoUrl(data.logo_path ? getLogoUrl(`${data.logo_path}`) : null);
      }
    } catch (error) {
      //console.error('Error fetching settings:', error);
      //message.error('ไม่สามารถโหลดข้อมูลบริษัทได้');
    } finally {
      setLoading(false);
    }
  };

  // Load data
  useEffect(() => {
    loadReceipts();
    loadCustomers();
    loadProducts();
  }, [pagination.current, pagination.pageSize, filters]);

  const loadReceipts = async () => {
    try {
      setLoading(true);
      const response = await getReceipts({
        page: pagination.current,
        limit: pagination.pageSize,
        ...filters
      });

      if (response.data.success) {
        const pageReceipts = response.data.data;
        const filteredTotal = response.data.pagination.total;
        let summary = response.data.summary;

        if (!summary) {
          let receiptsForSummary = pageReceipts;

          if (filteredTotal > pageReceipts.length) {
            const allReceiptsResponse = await getReceipts({
              page: 1,
              limit: filteredTotal,
              ...filters
            });

            if (allReceiptsResponse.data.success) {
              receiptsForSummary = allReceiptsResponse.data.data;
            }
          }

          summary = {
            total_sales: receiptsForSummary.reduce((sum, receipt) => sum + parseFloat(receipt.total_amount || 0), 0),
            total_receipts: filteredTotal,
            paid_receipts: receiptsForSummary.filter(receipt => receipt.status === 'paid').length,
            outstanding_amount: receiptsForSummary
              .filter(receipt => receipt.status !== 'paid' && receipt.status !== 'cancelled')
              .reduce((sum, receipt) => sum + Math.max(
                parseFloat(receipt.total_amount || 0) - parseFloat(receipt.paid_amount || 0),
                0
              ), 0)
          };
        }

        setReceipts(pageReceipts);
        setPagination(prev => ({
          ...prev,
          total: filteredTotal
        }));
        setSalesStats(summary || {
          total_sales: 0,
          total_receipts: 0,
          paid_receipts: 0,
          outstanding_amount: 0
        });
        setStatusCounts(response.data.statusCounts || []);
      }
    } catch (error) {
      //console.error('Error loading receipts:', error);
      //message.error('ไม่สามารถโหลดข้อมูลใบเสร็จได้');
    } finally {
      setLoading(false);
    }
  };

  const loadCustomers = async () => {
    try {
      const response = await getCustomersForDropdown();
      if (response.success) {
        setCustomers(response.data);
      }
    } catch (error) {
      //console.error('Error loading customers:', error);
    }
  };

  const handleOpenCustomerModal = () => {
    customerForm.resetFields();
    setCustomerModalVisible(true);
  };

  const handleCreateCustomer = async () => {
    try {
      const values = await customerForm.validateFields();
      setCustomerSaving(true);
      const response = await createContact({ ...values, type: 'customer' });
      const customerId = response?.data?.id;

      await loadCustomers();
      if (customerId) form.setFieldValue('contact_id', customerId);

      setCustomerModalVisible(false);
      customerForm.resetFields();
      message.success('เพิ่มลูกค้าใหม่และเลือกในใบเสร็จแล้ว');
    } catch (error) {
      if (error?.errorFields) return;
      message.error(error.response?.data?.message || 'ไม่สามารถเพิ่มลูกค้าใหม่ได้');
    } finally {
      setCustomerSaving(false);
    }
  };

  const loadProducts = async () => {
    try {
      const response = await getProducts({ limit: 1000 });
      if (response.success) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error('Error loading products:', error);
    }
  };



  const calculateTotals = (items, discount = 0, taxRate = 7, vatMode = 'exclude', whtRate = 0) => {
    const totalBeforeDiscount = (items || []).reduce((sum, item) => {
      if (!item || item.is_free) return sum; // ของแถมไม่รวมยอดขายและภาษี
      const qty = parseFloat(item.quantity) || 0;
      const price = parseFloat(item.unit_price) || 0;
      return sum + qty * price;
    }, 0);

    const discountAmount = Math.min(
      Math.max(0, parseFloat(discount) || 0),
      totalBeforeDiscount
    );

    let subtotal = 0;
    let taxAmount = 0;
    let totalAmount = 0;
    let whtAmount = 0;

    if (vatMode === 'include') {
      totalAmount = totalBeforeDiscount - discountAmount;
      subtotal = totalAmount / (1 + taxRate / 100);
      taxAmount = totalAmount - subtotal;
    } else if (vatMode === 'exclude') {
      subtotal = totalBeforeDiscount - discountAmount;
      taxAmount = (subtotal * taxRate) / 100;
      totalAmount = subtotal + taxAmount;
    } else {
      subtotal = totalBeforeDiscount - discountAmount;
      taxAmount = 0;
      totalAmount = subtotal;
    }

    if (whtRate > 0) {
      whtAmount = (subtotal * whtRate) / 100;
    }

    return {
      subtotal: parseFloat(subtotal.toFixed(2)),
      discount: parseFloat(discountAmount.toFixed(2)),
      subtotalAfterDiscount: parseFloat((subtotal).toFixed(2)),
      taxAmount: parseFloat(taxAmount.toFixed(2)),
      totalAmount: parseFloat(totalAmount.toFixed(2)),
      whtAmount: parseFloat(whtAmount.toFixed(2))
    };
  };


  // Barcode functions
  const handleBarcodeScanned = async (barcode) => {
    if (!barcode || barcode.trim() === '') return;

    try {
      setBarcodeLoading(true);

      const product = await findProductByBarcode(barcode.trim());

      if (product) {
        addProductToItems(product);
        message.success(`เพิ่มสินค้า: ${product.name}`);

        setBarcodeInput('');
        if (barcodeInputRef.current) {
          barcodeInputRef.current.focus();
        }
      } else {
        message.warning(`ไม่พบสินค้าที่มีบาร์โค้ด: ${barcode}`);
        setBarcodeInput('');
      }
    } catch (error) {
      console.error('Error scanning barcode:', error);
      message.error('เกิดข้อผิดพลาดในการสแกนบาร์โค้ด');
      setBarcodeInput('');
    } finally {
      setBarcodeLoading(false);
    }
  };

  const findProductByBarcode = async (barcode) => {
    const local = products.find(product =>
      product.barcode && product.barcode === barcode
    );
    if (local) return local;
    try { return await getProductByBarcode(encodeURIComponent(barcode)); }
    catch { return null; }
  };

  const addProductToItems = (product) => {
    const currentItems = form.getFieldValue('items') || [];

    const existingItemIndex = currentItems.findIndex(item =>
      item.product_id === product.id && !item.is_free
    );

    if (existingItemIndex >= 0) {
      const updatedItems = [...currentItems];
      updatedItems[existingItemIndex].quantity = (updatedItems[existingItemIndex].quantity || 1) + 1;
      form.setFieldsValue({ items: updatedItems });
    } else {
      const newItem = {
        product_id: product.id,
        product_unit_id: product.matched_unit?.id || product.units?.find(unit => unit.is_default_sale)?.id || product.units?.find(unit => unit.is_base)?.id,
        description: product.name,
        quantity: 1,
        unit_price: product.matched_unit?.sale_price ?? product.units?.find(unit => unit.is_default_sale)?.sale_price ?? product.price ?? 0,
        is_free: false
      };

      form.setFieldsValue({
        items: [...currentItems, newItem]
      });
    }
  };

  const handleBarcodeInputChange = (e) => {
    setBarcodeInput(e.target.value);
  };

  const handleBarcodeInputKeyPress = (e) => {
    if (e.key === 'Enter' && barcodeInput.trim()) {
      handleBarcodeScanned(barcodeInput);
    }
  };

  const clearBarcodeInput = () => {
    setBarcodeInput('');
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
    }
  };

  // Modal handlers
  const showCreateModal = () => {
    setEditingReceipt(null);
    setModalVisible(true);
    setBarcodeMode(false);
    setBarcodeInput('');
    form.resetFields();
    form.setFieldsValue({
      receipt_date: dayjs(),
      tax_rate: 7,
      vat_mode: 'exclude',
        items: [{ description: '', quantity: 1, unit_price: 0, is_free: false }]
    });
  };

  const [calcValues, setCalcValues] = useState({
    subtotal: 0,
    discount: 0,
    subtotalAfterDiscount: 0,
    taxAmount: 0,
    totalAmount: 0
  });

  const calculateSummary = (items = [], discount = 0, taxRate = 0, vatMode = 'exclude') => {
    const subtotal = items.reduce((sum, item) => {
      const qty = parseFloat(item.quantity) || 0;
      const price = parseFloat(item.unit_price) || 0;
      return item?.is_free ? sum : sum + qty * price;
    }, 0);

    const discountAmount = Math.min(
      Math.max(0, parseFloat(discount) || 0),
      subtotal
    );
    const subtotalAfterDiscount = subtotal - discountAmount;

    let taxAmount = 0;
    if (vatMode === 'include') {
      taxAmount = subtotalAfterDiscount - subtotalAfterDiscount / (1 + taxRate / 100);
    } else {
      taxAmount = subtotalAfterDiscount * (taxRate / 100);
    }

    const totalAmount = subtotalAfterDiscount + (vatMode === 'exclude' ? taxAmount : 0);

    return {
      subtotal,
      discount: discountAmount,
      subtotalAfterDiscount,
      taxAmount,
      totalAmount
    };
  };

  const showEditModal = (record) => {
    setEditingReceipt(record);
    setModalVisible(true);
    setBarcodeMode(false);
    setBarcodeInput('');

    form.setFieldsValue({
      contact_id: record.contact_id,
      receipt_date: dayjs(record.receipt_date),
      due_date: record.due_date ? dayjs(record.due_date) : null,
      discount: record.discount,
      tax_rate: record.tax_rate,
      vat_mode: record.vat_mode || 'include',
      total_amount: record.total_amount,
      tax_amount: record.tax_amount,
      subtotal: record.subtotal,
      notes: record.notes,
      status: record.status
    });

    if (record.id) {
      loadReceiptForEdit(record.id);
    }
  };

  // --------- แก้ไข loadReceiptForEdit ---------
  const loadReceiptForEdit = async (id) => {
    try {
      const response = await getReceiptById(id);
      if (response.data.success) {
        const receipt = response.data.data;

        const items = (receipt.items && receipt.items.length > 0)
          ? receipt.items.map(item => ({
            product_id: item.product_id,
            product_unit_id: item.product_unit_id,
            description: item.description,
            quantity: parseFloat(item.quantity) || 0,
            unit_price: parseFloat(item.unit_price) || 0,
            is_free: Boolean(item.is_free)
          }))
          : [{ description: '-', quantity: 1, unit_price: 0 }];

        // ใส่ค่าในฟอร์ม
        form.setFieldsValue({
          ...form.getFieldsValue(),
          contact_id: receipt.contact_id,
          receipt_date: receipt.receipt_date ? dayjs(receipt.receipt_date) : dayjs(),
          due_date: receipt.due_date ? dayjs(receipt.due_date) : undefined,
          invoice_number: receipt.invoice_number,
          discount: parseFloat(receipt.discount) || 0,
          tax_rate: parseFloat(receipt.tax_rate) || 7,
          vat_mode: receipt.vat_mode || 'exclude',
          status: receipt.status || 'invoice',
          totalAmount: receipt.totalAmount,
          notes: receipt.notes || '',
          items
        });

        setCalcValues({
          subtotal: 1,
          discount: 1,
          subtotalAfterDiscount: 1,
          taxAmount: 1,
          totalAmount: 1
        })

        // ✅ คำนวณสรุปยอดทันทีหลังโหลด
        handleFormChange();
      }
    } catch (error) {
      console.error('Error loading receipt for edit:', error);
    }
  };


  const handleFormChange = () => {
    const items = form.getFieldValue('items') || [];
    const discount = form.getFieldValue('discount') || 0;
    const taxRate = form.getFieldValue('tax_rate') || 7;
    const currentVatMode = form.getFieldValue('vat_mode') || 'exclude';

    const calculations = calculateTotals(items, discount, taxRate, currentVatMode);
    setCalcValues(calculations);
  };

  const showDetailDrawer = async (record) => {
    try {
      setLoading(true);
      const response = await getReceiptById(record.id);
      if (response.data.success) {
        setSelectedReceipt(response.data.data);
        setDetailDrawerVisible(true);
      }
    } catch (error) {
      console.error('Error loading receipt details:', error);
      message.error('ไม่สามารถโหลดรายละเอียดใบเสร็จได้');
    } finally {
      setLoading(false);
    }
  };

  const showPaymentModal = (record) => {
    setPaymentReceipt(record);
    setPaymentModalVisible(true);
    paymentForm.resetFields();
    paymentForm.setFieldsValue({
      paid_amount: record.total_amount - (record.paid_amount || 0)
    });
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setEditingReceipt(null);
    setBarcodeMode(false);
    setBarcodeInput('');
    form.resetFields();
  };

  const handleClosePaymentModal = () => {
    setPaymentModalVisible(false);
    setPaymentReceipt(null);
    paymentForm.resetFields();
  };

  const handleClosePdfModal = () => {
    setPdfModalVisible(false);
    setPdfDataUrl('');
    setPdfFileName('');
    setPdfPreviewReceipt(null);
    setPdfLoading(false);
    setPdfPreviewKind('receipt');
  };

  // CRUD operations
  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const items = (values.items || []).map(item => ({
        product_id: item.product_id || null,
        product_unit_id: item.product_unit_id || null,
        description: item.description,
        quantity: parseFloat(item.quantity) || 0,
        unit_price: parseFloat(String(item.unit_price).replace(/,/g, '')) || 0,
        is_free: Boolean(item.is_free),
        total_price: item.is_free ? 0 : (parseFloat(item.quantity) || 0) * (parseFloat(String(item.unit_price).replace(/,/g, '')) || 0)
      }));

      const discount = values.discount || 0;
      const taxRate = values.tax_rate || 0;
      const vatMode = values.vat_mode || 'exclude';

      const calcValues = calculateTotals(items, discount, taxRate, vatMode);



      const receiptData = {
        ...values,
        receipt_date: values.receipt_date.format('YYYY-MM-DD'),
        due_date: values.due_date ? values.due_date.format('YYYY-MM-DD') : null,
        subtotal: calcValues.subtotal,
        discount: calcValues.discount,
        tax_amount: calcValues.taxAmount,
        total_amount: calcValues.totalAmount,
        vat_mode: vatMode,
        items // ✅ ใช้ที่ parse แล้ว
      };
      delete receiptData.receipt_number;

      if (editingReceipt) {
        await updateReceipt(editingReceipt.id, receiptData);
        message.success('แก้ไขใบเสร็จเรียบร้อยแล้ว');
      } else {
        await createReceipt(receiptData);
        message.success('สร้างใบเสร็จเรียบร้อยแล้ว');
      }

      handleCloseModal();
      loadReceipts();
    } catch (error) {
      console.error('Error saving receipt:', error);
      message.error('เกิดข้อผิดพลาดในการบันทึกใบเสร็จ');
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = async (values) => {
    try {
      setLoading(true);

      const data = {
        paid_amount: parseFloat(values.paid_amount),
        payment_method: values.payment_method,
        payment_date: values.payment_date.format('YYYY-MM-DD'),
        reference_no: values.reference_no,
        bank_name: values.bank_name,
        bank_account_no: values.bank_account_no,
        notes: values.notes
      }

      await payReceipt(paymentReceipt.id, data);
      message.success('บันทึกการชำระเงินเรียบร้อยแล้ว');
      handleClosePaymentModal();
      loadReceipts();

    } catch (error) {
      console.error('Error recording payment:', error);
      message.error(error.response?.data?.message || 'เกิดข้อผิดพลาดในการบันทึกการชำระเงิน');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await deleteReceipt(id);
      message.success('ลบใบเสร็จเรียบร้อยแล้ว');
      loadReceipts();
    } catch (error) {
      console.error('Error deleting receipt:', error);
      message.error('เกิดข้อผิดพลาดในการลบใบเสร็จ');
    } finally {
      setLoading(false);
    }
  };

  const handlePrintTable = async () => {
    try {
      setLoading(true);
      setPdfLoading(true);
      const dataUrl = await generateReceiptsTablePDF(receipts, company, filters, salesStats);
      setPdfPreviewReceipt(null);
      setPdfPreviewKind('table');
      setMobilePrintTab('preview');
      setPdfDataUrl(dataUrl);
      setPdfFileName(`receipts-report-${dayjs().format('YYYYMMDD-HHmm')}.pdf`);
      setPdfModalVisible(true);
    } catch (error) {
      console.error('Error printing table:', error);
      message.error('ไม่สามารถพิมพ์ตารางได้');
    } finally {
      setLoading(false);
      setPdfLoading(false);
    }
  };

  // Mobile Receipt Card Component
  const ReceiptCard = ({ receipt }) => (
    <Card
      size="small"
      style={{ marginBottom: 16 }}
      actions={[
        <Tooltip title="ดูรายละเอียด">
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={() => showDetailDrawer(receipt)}
            size="small"
          />
        </Tooltip>,
        receipt.status !== 'paid' && isSuperAdmin && (
          <Tooltip title="บันทึกการชำระ">
            <Button
              type="text"
              icon={<PayCircleOutlined />}
              onClick={() => showPaymentModal(receipt)}
              size="small"
              style={{ color: '#52c41a' }}
            />
          </Tooltip>
        ),

        isSuperAdmin && (
          <Tooltip title="แก้ไข">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => showEditModal(receipt)}
              size="small"
            />
          </Tooltip>),

        receipt.fulfillment_status !== 'fulfilled' && hasPermission('inventory', 'fulfill') && (
          <Tooltip title="ยืนยันส่งมอบ / ตัดสต็อก">
            <Button type="text" icon={<SendOutlined />} size="small" style={{ color: '#1677ff' }}
              onClick={() => openFulfillmentPreview(receipt)} />
          </Tooltip>
        ),

        < Tooltip title="พิมพ์" >
          <Button
            type="text"
            icon={<PrinterOutlined />}
            onClick={() => handlePrint(receipt)}
            size="small"
            style={{ color: '#7e57c2' }}
          />
        </Tooltip >,
        receipt.status !== 'paid' && isSuperAdmin && (
          <Popconfirm
            title="คุณแน่ใจหรือไม่ที่จะลบใบเสร็จนี้?"
            onConfirm={() => handleDelete(receipt.id)}
            okText="ใช่"
            cancelText="ไม่"
          >
            <Tooltip title="ลบ">
              <Button
                type="text"
                icon={<DeleteOutlined />}
                danger
                size="small"
              />
            </Tooltip>
          </Popconfirm>
        )
      ].filter(Boolean)}
    >
      <div onClick={() => showDetailDrawer(receipt)} style={{ cursor: 'pointer' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <strong>{receipt.invoice_number}</strong>
          <Tag color={getReceiptStatusColor(receipt.status)}>
            {getReceiptStatusLabel(receipt.status)}
          </Tag>
        </div>

        {receipt.receipt_number && (
          <div style={{ fontSize: '12px', color: '#666', marginBottom: 4 }}>
            เลขที่เสร็จ: {receipt.receipt_number}
          </div>
        )}

        <div style={{ marginBottom: 8 }}>
          <div style={{ fontWeight: 'bold', color: '#1890ff' }}>{receipt.contact_name}</div>
          {receipt.company_name && (
            <div style={{ fontSize: '12px', color: '#666' }}>{receipt.company_name}</div>
          )}
        </div>

        <Row gutter={16} style={{ fontSize: '12px', color: '#666', marginBottom: 8 }}>
          <Col span={12}>
            <CalendarOutlined style={{ marginRight: 4 }} />
            {dayjs(receipt.receipt_date).format('DD/MM/YYYY')}
          </Col>
          <Col span={12} style={{ textAlign: 'right' }}>
            <DollarOutlined style={{ marginRight: 4 }} />
            ฿{parseFloat(receipt.total_amount).toLocaleString()}
          </Col>
        </Row>

        {receipt.paid_amount > 0 && (
          <div style={{ fontSize: '12px', color: '#52c41a', marginBottom: 4 }}>
            ชำระแล้ว: ฿{parseFloat(receipt.paid_amount).toLocaleString()}
          </div>
        )}

        {receipt.due_date && (
          <div style={{ fontSize: '12px', color: '#666' }}>
            กำหนดชำระ: {dayjs(receipt.due_date).format('DD/MM/YYYY')}
          </div>
        )}
      </div>
    </Card >
  );

  // Table columns
  const handleConfirmProduction = (record) => {
    Modal.confirm({
      title: 'ยืนยันผลิตและตัดวัสดุ',
      content: 'ระบบจะตัดวัสดุจากม้วนแบบ FIFO บันทึกต้นทุนจริง และสร้างรายการบัญชีต้นทุนขาย',
      okText: 'ยืนยันผลิต',
      onOk: async () => {
        try {
          const response = await confirmReceiptProduction(record.id);
          message.success(`ยืนยันผลิตแล้ว ต้นทุนวัสดุ ${Number(response.data.data.material_cost || 0).toLocaleString('th-TH')} บาท`);
          loadReceipts();
        } catch (error) {
          if (error.response?.status === 422) {
            let reason = '';
            Modal.confirm({
              title: 'วัสดุไม่เพียงพอ',
              content: <Input.TextArea placeholder="ระบุเหตุผลอนุมัติสต็อกติดลบ" onChange={event => { reason = event.target.value; }} />,
              okText: 'อนุมัติและดำเนินการ',
              onOk: async () => {
                await confirmReceiptProduction(record.id, { allow_negative: true, override_reason: reason });
                message.success('ยืนยันผลิตพร้อมบันทึกเหตุผลสต็อกติดลบแล้ว');
                loadReceipts();
              }
            });
          } else message.error(error.response?.data?.message || 'ยืนยันผลิตไม่สำเร็จ');
        }
      }
    });
  };

  const handleCancelProduction = record => {
    let reason = '';
    Modal.confirm({ title: 'คืนวัสดุและกลับรายการต้นทุนขาย', content: <Input.TextArea placeholder="ระบุเหตุผล" onChange={event => { reason = event.target.value; }} />,
      okText: 'ยืนยันคืนวัสดุ', okButtonProps: { danger: true }, onOk: async () => { await cancelReceiptProduction(record.id, reason); message.success('คืนวัสดุและกลับรายการบัญชีแล้ว');
        loadReceipts(); } });
  };

  const openFulfillmentPreview = async record => {
    setFulfillmentOpen(true);
    setFulfillmentLoading(true);
    setFulfillmentData(null);
    setFulfillmentReason('');
    setFulfilledDate(dayjs());
    try {
      const data = await inventoryService.fulfillmentPreview(record.id);
      setFulfillmentData(data);
      setFulfillmentSerials(Object.fromEntries((data.items || []).map(item => [
        item.receipt_item_id,
        (item.reserved_serials || []).map(serial => serial.id)
      ])));
    } catch (error) {
      message.error(error.response?.data?.message || 'โหลดตัวอย่างการส่งมอบไม่สำเร็จ');
      setFulfillmentOpen(false);
    } finally {
      setFulfillmentLoading(false);
    }
  };

  const confirmFulfillment = async () => {
    if (!fulfillmentData?.receipt?.id) return;
    const hasShortage = (fulfillmentData.items || []).some(item => Number(item.shortage_quantity_base) > 0);
    if (hasShortage && !fulfillmentReason.trim()) {
      return message.warning('กรุณาระบุเหตุผลการอนุมัติสต็อกติดลบ');
    }
    setFulfillmentLoading(true);
    try {
      for (const item of fulfillmentData.items || []) {
        if (!item.track_serial) continue;
        const required = Math.trunc(Number(item.quantity_base || item.quantity || 0));
        const selected = fulfillmentSerials[item.receipt_item_id] || [];
        const availableCount = (item.reserved_serials || []).length + (item.available_serials || []).length;
        // When stock is short, selected serials cover only existing stock; the
        // backend creates auditable TMP serials for the missing quantity.
        if (!hasShortage && selected.length !== required) {
          throw new Error(`กรุณาเลือก Serial ของ ${item.name} ให้ครบ ${required} รายการ`);
        }
        if (availableCount >= required && selected.length === required) {
          await inventoryService.selectSerials(fulfillmentData.receipt.id, item.receipt_item_id, selected);
        }
      }
      const result = await inventoryService.confirmFulfillment(fulfillmentData.receipt.id, {
        fulfilled_date: fulfilledDate.format('YYYY-MM-DD'),
        allow_negative: hasShortage,
        reason: hasShortage ? fulfillmentReason.trim() : undefined
      });
      message.success(`ยืนยันส่งมอบแล้ว ต้นทุน FIFO ${Number(result.data?.inventory_cost || 0).toLocaleString('th-TH')} บาท`);
      setFulfillmentOpen(false);
      setFulfillmentData(null);
      loadReceipts();
    } catch (error) {
      message.error(error.response?.data?.message || error.message || 'ยืนยันส่งมอบไม่สำเร็จ');
    } finally {
      setFulfillmentLoading(false);
    }
  };

  const columns = [
    {
      title: 'เลขที่เอกสาร',
      key: 'document_number',
      width: 150,
      render: (text, record) => (
        <div>
          <Button
            type="link"
            onClick={() => showDetailDrawer(record)}
            style={{ padding: 0, height: 'auto' }}
          >
            {record.invoice_number}
          </Button>
          {record.receipt_number && (
            <div style={{ fontSize: '12px', color: '#666' }}>
              {record.receipt_number}
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'ลูกค้า',
      key: 'customer',
      width: 200,
      render: (text, record) => (
        <div>
          <div>{record.contact_name}</div>
          {record.company_name && (
            <div style={{ fontSize: '12px', color: '#666' }}>
              {record.company_name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'วันที่',
      dataIndex: 'receipt_date',
      key: 'receipt_date',
      width: 120,
      render: (date) => dayjs(date).format('DD/MM/YYYY'),
    },
    {
      title: 'กำหนดชำระ',
      dataIndex: 'due_date',
      key: 'due_date',
      width: 120,
      responsive: ['xxl'],
      render: (date) => date ? dayjs(date).format('DD/MM/YYYY') : '-',
    },
    {
      title: 'ยอดเงิน',
      key: 'amount',
      width: 150,
      align: 'right',
      render: (text, record) => (
        <div>
          <div>{parseFloat(record.total_amount).toLocaleString()}</div>
          {record.paid_amount > 0 && (
            <div style={{ fontSize: '12px', color: '#52c41a' }}>
              ชำระแล้ว {parseFloat(record.paid_amount).toLocaleString()}
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'ภาษี',
      key: 'tax_amount',
      width: 150,
      responsive: ['xxl'],
      align: 'right',
      render: (text, record) => (
        <div>{parseFloat(record.tax_amount).toLocaleString()}</div>
      ),
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status) => (
        <Tag color={getReceiptStatusColor(status)}>
          {getReceiptStatusLabel(status)}
        </Tag>
      ),
    },
    {
      title: 'ประเภทธุรกิจ',
      key: 'accounting_preset_id',
      width: 190,
      render: (_, record) => <DocumentPresetQuickSelect documentType="receipt" documentId={record.id}
        value={record.accounting_preset_id} accountingStatus={record.accounting_status}
        onChanged={presetId => setReceipts(current => current.map(item => item.id === record.id ? { ...item, accounting_preset_id: presetId } : item))} />
    },
    {
      title: 'การดำเนินการ',
      key: 'action',
      width: 126,
      fixed: 'right',
      render: (_, record) => (
        <Space size={4} wrap={false}>
          <Tooltip title="ดูรายละเอียด">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              size="small"
              onClick={() => showDetailDrawer(record)}
            />
          </Tooltip>
          <Tooltip title="พิมพ์">
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              size="small"
              style={{ backgroundColor: '#7e57c2', borderColor: '#7e57c2' }}
              onClick={() => handlePrint(record)}
            />
          </Tooltip>
          <Dropdown trigger={['click']} placement="bottomRight" menu={{ items: [
            record.status !== 'paid' && isSuperAdmin && { key:'payment', label:'บันทึกการชำระ', icon:<PayCircleOutlined />, onClick:() => showPaymentModal(record) },
            isSuperAdmin && { key:'edit', label:'แก้ไข', icon:<EditOutlined />, onClick:() => showEditModal(record) },
            { key:'accounting', label:record.accounting_status === 'posted' ? 'ลงบัญชีแล้ว' : 'ลงบัญชี', icon:<BookOutlined />,
              disabled:record.accounting_status === 'posted', onClick:() => handlePostToAccounting(record) },
            record.fulfillment_status !== 'fulfilled' && hasPermission('inventory', 'fulfill') &&
              { key:'fulfill', label:'ยืนยันส่งมอบ', icon:<SendOutlined />, onClick:() => openFulfillmentPreview(record) },
            record.production_status === 'reserved' &&
              { key:'produce', label:'ยืนยันผลิต', onClick:() => handleConfirmProduction(record) },
            record.production_status === 'confirmed' && isSuperAdmin &&
              { key:'return-material', label:'คืนวัสดุ', onClick:() => handleCancelProduction(record) },
            record.status !== 'paid' && isSuperAdmin && { key:'delete', label:'ลบใบเสร็จ', icon:<DeleteOutlined />, danger:true,
              onClick:() => Modal.confirm({ title:'คุณแน่ใจหรือไม่ที่จะลบใบเสร็จนี้?', okText:'ใช่', cancelText:'ไม่', okButtonProps:{ danger:true }, onOk:() => handleDelete(record.id) }) }
          ].filter(Boolean) }}>
            <Button size="small" icon={<MoreOutlined />} aria-label="การดำเนินการเพิ่มเติม" />
          </Dropdown>
        </Space>
      ),
    },
  ];

  const handlePrint = async (record) => {
    try {
      message.loading('กำลังสร้าง PDF...', 1);

      const response = await getReceiptById(record.id);

      if (response.data.success) {
        const receiptData = response.data.data;

        const companyInfo = {
          name: company.company_name || 'ชื่อบริษัทของคุณ',
          address: 'ที่อยู่บริษัทของคุณ',
          phone: 'หมายเลขโทรศัพท์บริษัท'
        };

        setPdfPreviewKind('receipt');
        setPdfPreviewReceipt(receiptData);
        setMobilePrintTab('preview');
        setPdfModalVisible(true);

      }
    } catch (error) {
      console.error('PDF generation error:', error);
      message.error('เกิดข้อผิดพลาดในการสร้าง PDF: ' + error.message);
    }
  };

  const handlePostToAccounting = async (record) => {
    setPostingReceipt(record);
  };

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const handleSearch = (value) => {
    setFilters(prev => ({ ...prev, search: value }));
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const handleStatusFilter = (value) => {
    setFilters(prev => ({ ...prev, status: value }));
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const handleCustomerFilter = (value) => {
    setFilters(prev => ({ ...prev, contact_id: value }));
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const clearFilters = () => {
    setFilters({ search: '', status: '', contact_id: '', start_date: '', end_date: '' });
    setSelectedDateRange([null, null]);
    setSelectedQuickFilter('all');
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  return (
    <div className={`receipts-page ${isMobile ? 'mobile-layout' : ''}`} style={{ padding: isMobile ? 0 : '24px' }}>

      {/* Modal แสดง PDF */}
      <AccountingPostingPreviewModal open={Boolean(postingReceipt)} documentType="receipt" documentId={postingReceipt?.id}
        onClose={() => setPostingReceipt(null)} onPosted={loadReceipts} />

      <Modal
        title="ตรวจสอบและยืนยันส่งมอบสินค้า"
        open={fulfillmentOpen}
        onCancel={() => setFulfillmentOpen(false)}
        onOk={confirmFulfillment}
        okText="ยืนยันส่งมอบและตัดสต็อก"
        cancelText="ยกเลิก"
        confirmLoading={fulfillmentLoading}
        width={isMobile ? '100%' : 760}
        styles={{ body: { maxHeight: isMobile ? '68vh' : '70vh', overflowY: 'auto', paddingBottom: isMobile ? 88 : 24 } }}
      >
        {fulfillmentLoading && !fulfillmentData ? <div style={{ textAlign: 'center', padding: 32 }}><Spin /></div> : <>
          <Alert type="info" showIcon style={{ marginBottom: 16 }}
            message="ระบบจะตัดล็อตเก่าก่อน (FIFO) และสร้าง Draft Journal ต้นทุนขาย"
            description="สต็อกและวันเริ่มรับประกันจะถูกล็อก ณ วันที่ยืนยันส่งมอบ" />
          <Form layout="vertical">
            <Form.Item label="วันที่ส่งมอบ / วันเริ่มรับประกัน">
              <DatePicker value={fulfilledDate} onChange={value => value && setFulfilledDate(value)}
                format="DD/MM/YYYY" style={{ width: '100%' }} allowClear={false} />
            </Form.Item>
          </Form>
          {(fulfillmentData?.items || []).map(item => {
            const shortage = Number(item.shortage_quantity_base || 0);
            const serialOptions = [...(item.reserved_serials || []), ...(item.available_serials || [])]
              .filter((serial, index, rows) => rows.findIndex(row => Number(row.id) === Number(serial.id)) === index)
              .map(serial => ({ value: serial.id, label: serial.serial_number }));
            return <Card key={item.receipt_item_id} size="small" style={{ marginBottom: 10 }}
              title={item.name} extra={<Tag color={shortage > 0 ? 'red' : 'green'}>{shortage > 0 ? `ขาด ${shortage}` : 'พร้อมส่ง'}</Tag>}>
              <Descriptions size="small" column={isMobile ? 1 : 3}>
                <Descriptions.Item label="จำนวนขาย">{item.quantity} {item.unit_name_snapshot || ''}</Descriptions.Item>
                <Descriptions.Item label="หน่วยฐาน">{item.quantity_base}</Descriptions.Item>
                <Descriptions.Item label="จองแล้ว">{item.reserved_quantity_base}</Descriptions.Item>
              </Descriptions>
              {item.track_serial ? <div style={{ marginTop: 10 }}>
                <Text strong>Serial Number ที่ส่งมอบ</Text>
                <Select mode="multiple" showSearch style={{ width: '100%', marginTop: 6 }}
                  value={fulfillmentSerials[item.receipt_item_id] || []}
                  onChange={value => setFulfillmentSerials(current => ({ ...current, [item.receipt_item_id]: value }))}
                  options={serialOptions} placeholder="เลือกหรือสแกน Serial ให้ครบตามจำนวน" />
                {shortage > 0 && <Text type="warning">ส่วนที่ขาดจะสร้าง Serial ชั่วคราว TMP และผูก Serial จริงภายหลังได้</Text>}
              </div> : null}
            </Card>;
          })}
          {(fulfillmentData?.items || []).some(item => Number(item.shortage_quantity_base) > 0) && <Alert
            type="warning" showIcon message="สต็อกไม่เพียงพอ ต้องใช้สิทธิ์อนุมัติสต็อกติดลบ"
            description={<Input.TextArea value={fulfillmentReason} onChange={event => setFulfillmentReason(event.target.value)}
              rows={3} placeholder="ระบุเหตุผลที่อนุมัติให้ส่งมอบก่อนรับสินค้าเข้า" />} />}
        </>}
      </Modal>

      <Modal
        className="receipt-print-modal"
        title={
          <div className="receipt-print-modal-title">
            <span className="receipt-print-modal-title-icon"><FileTextOutlined /></span>
            <span>
              <strong>{pdfPreviewKind === 'table' ? 'ตัวอย่างรายงานใบเสร็จ/ใบแจ้งหนี้' : 'ใบเสร็จ/ใบแจ้งหนี้'}</strong>
              <small>{pdfPreviewKind === 'table' ? 'ตรวจสอบรายงานก่อนดาวน์โหลด' : `${pdfPreviewReceipt?.invoice_number || 'เอกสารขาย'} · ตั้งค่ารูปแบบและตรวจสอบก่อนดาวน์โหลด`}</small>
            </span>
          </div>
        }
        open={pdfModalVisible}
        onCancel={handleClosePdfModal}
        footer={[
          <Button key="close" onClick={handleClosePdfModal}>ปิดหน้าต่าง</Button>,
          <Button key="download" type="primary" icon={<FileTextOutlined />} onClick={handleDownloadPdf} disabled={!pdfDataUrl || pdfLoading}>
            ดาวน์โหลด PDF
          </Button>
        ]}
        width={isMobile ? '100vw' : 'min(1480px, calc(100vw - 32px))'}
        centered
      >
        <div className={`receipt-print-workspace${pdfPreviewKind === 'table' ? ' receipt-print-workspace--report' : ''}`}>
        {isMobile && pdfPreviewKind === 'receipt' && <div className="receipt-print-mobile-tabs" role="tablist" aria-label="ส่วนของหน้าต่างพิมพ์เอกสาร">
          <button type="button" role="tab" aria-selected={mobilePrintTab === 'settings'}
            className={mobilePrintTab === 'settings' ? 'is-active' : ''}
            onClick={() => setMobilePrintTab('settings')}>ตั้งค่าเอกสาร</button>
          <button type="button" role="tab" aria-selected={mobilePrintTab === 'preview'}
            className={mobilePrintTab === 'preview' ? 'is-active' : ''}
            onClick={() => setMobilePrintTab('preview')}>ตัวอย่าง PDF</button>
        </div>}
        {pdfPreviewKind === 'receipt' && <aside className={`receipt-print-settings${isMobile && mobilePrintTab !== 'settings' ? ' receipt-print-mobile-hidden' : ''}`}>
          <div className="receipt-print-settings-heading">
            <span className="receipt-print-eyebrow">DOCUMENT SETTINGS</span>
            <h3>ตั้งค่าเอกสาร</h3>
            <p>เลือกรูปแบบและข้อมูลที่ต้องการแสดง</p>
          </div>
          <div className="receipt-print-setting-label">รูปแบบเอกสาร</div>
          <Radio.Group
            className="receipt-print-format-options"
            value={printType}
            onChange={(e) => {
              const value = e.target.value;
              setPrintType(value);
              localStorage.setItem('PRINT_TYPE', value);
            }}
          >
            <Radio value="full">แบบฟอร์มเต็ม</Radio>
            <Radio value="a4_reference">แบบ A4 มาตรฐาน (ต้นฉบับ)</Radio>
            <Radio value="delivery_invoice">ใบส่งของ/ใบแจ้งหนี้ (ตามตัวอย่าง)</Radio>
            <Radio value="dot">แบบฟอร์มสำหรับเครื่อง Dot Matrix</Radio>
          </Radio.Group>
          <div className="receipt-print-setting-divider" />
          <Row gutter={[16, 12]}>
            {printType === 'delivery_invoice' && <Col xs={24} md={12}>
              <Text strong>ขนาดอักษรในเอกสาร</Text>
              <Select
                value={Number(receiptPrintOptions.delivery_invoice_font_scale) || 1}
                onChange={value => updateReceiptPrintOptions({ delivery_invoice_font_scale: value })}
                options={[
                  { value: 0.9, label: 'เล็ก (90%)' },
                  { value: 1, label: 'ปกติ (100%)' },
                  { value: 1.1, label: 'ใหญ่ (110%)' }
                ]}
                style={{ width: '100%', marginTop: 6 }}
              />
            </Col>}
            <Col xs={24} md={printType === 'delivery_invoice' ? 12 : 24}>
              <Text strong>วันที่เอกสาร</Text>
              <div style={{ marginTop: 10 }}>
                <Space>
                  <Switch
                    checked={receiptPrintOptions.show_document_date !== false}
                    onChange={checked => updateReceiptPrintOptions({ show_document_date: checked })}
                  />
                  <Text>{receiptPrintOptions.show_document_date !== false ? 'แสดงวันที่' : 'ซ่อนวันที่'}</Text>
                </Space>
              </div>
            </Col>
          </Row>
          <Collapse
            size="small"
            style={{ marginTop: 12 }}
            items={[{
              key: 'receipt-print-options',
              label: <Space><UserOutlined />{printType === 'delivery_invoice' ? 'ตั้งค่าเอกสาร พนักงานขาย และรูปภาพ' : 'ตั้งค่าผู้รับเงิน พนักงานขาย และรูปภาพ'}</Space>,
              children: (
                <Row gutter={[16, 12]}>
                  {printType !== 'delivery_invoice' && <Col xs={24} md={12}>
                    <Text strong>ชื่อผู้รับเงิน</Text>
                    <Radio.Group
                      size="small"
                      buttonStyle="solid"
                      value={receiptPrintOptions.collector_mode}
                      onChange={event => updateReceiptPrintOptions({ collector_mode: event.target.value })}
                      style={{ display: 'flex', marginTop: 6 }}
                    >
                      <Radio.Button value="current_user" style={{ flex: 1, textAlign: 'center' }}>User ปัจจุบัน</Radio.Button>
                      <Radio.Button value="custom" style={{ flex: 1, textAlign: 'center' }}>กำหนดเอง</Radio.Button>
                    </Radio.Group>
                    {receiptPrintOptions.collector_mode === 'custom' ? (
                      <Input
                        value={receiptPrintOptions.collector_custom_name}
                        onChange={event => updateReceiptPrintOptions({ collector_custom_name: event.target.value })}
                        placeholder="กรอกชื่อผู้รับเงิน"
                        style={{ marginTop: 8 }}
                      />
                    ) : (
                      <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
                        ใช้ชื่อ: {user?.name || user?.email || 'ไม่พบชื่อผู้ใช้งาน'}
                      </Text>
                    )}
                  </Col>}
                  <Col xs={24} md={12}>
                    <Text strong>พนักงานขาย</Text>
                    <Radio.Group
                      size="small"
                      buttonStyle="solid"
                      value={receiptPrintOptions.salesperson_mode}
                      onChange={event => updateReceiptPrintOptions({ salesperson_mode: event.target.value })}
                      style={{ display: 'flex', marginTop: 6 }}
                    >
                      <Radio.Button value="current_user" style={{ flex: 1, textAlign: 'center' }}>User ปัจจุบัน</Radio.Button>
                      <Radio.Button value="custom" style={{ flex: 1, textAlign: 'center' }}>กำหนดเอง</Radio.Button>
                    </Radio.Group>
                    {receiptPrintOptions.salesperson_mode === 'custom' ? (
                      <Input
                        value={receiptPrintOptions.salesperson_custom_name}
                        onChange={event => updateReceiptPrintOptions({ salesperson_custom_name: event.target.value })}
                        placeholder="กรอกชื่อพนักงานขาย"
                        style={{ marginTop: 8 }}
                      />
                    ) : (
                      <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
                        ใช้ชื่อ: {user?.name || user?.email || 'ไม่พบชื่อผู้ใช้งาน'}
                      </Text>
                    )}
                  </Col>
                  <Col xs={24}>
                    <Space size="large" wrap>
                      <Space>
                        <Switch
                          checked={Boolean(company?.signature_path) && (printType === 'delivery_invoice'
                            ? receiptPrintOptions.delivery_invoice_show_signature !== false
                            : receiptPrintOptions.show_signature)}
                          onChange={checked => updateReceiptPrintOptions(printType === 'delivery_invoice'
                            ? { delivery_invoice_show_signature: checked }
                            : { show_signature: checked })}
                          disabled={!company?.signature_path}
                        />
                        <Text>{printType === 'delivery_invoice' ? 'แสดงลายเซ็นผู้ส่งของ' : 'แสดงลายเซ็น'}</Text>
                        {!company?.signature_path && <Text type="secondary">(ยังไม่ได้อัปโหลด)</Text>}
                      </Space>
                      <Space>
                        <Switch
                          checked={Boolean(company?.stamp_path) && receiptPrintOptions.show_stamp}
                          onChange={checked => updateReceiptPrintOptions({ show_stamp: checked })}
                          disabled={!company?.stamp_path}
                        />
                        <Text>แสดงตราประทับบริษัท</Text>
                        {!company?.stamp_path && <Text type="secondary">(ยังไม่ได้อัปโหลด)</Text>}
                      </Space>
                    </Space>
                  </Col>
                </Row>
              )
            }]}
          />
          {printType !== 'dot' && printType !== 'delivery_invoice' && <SignatureLayoutControls
            documentType="receipt"
            value={signatureLayout}
            onChange={setSignatureLayout}
            onSave={handleSaveSignatureLayout}
            saving={signatureLayoutSaving}
          />}
          {isMobile && <Button type="primary" block className="receipt-print-view-preview"
            onClick={() => setMobilePrintTab('preview')}>ดูตัวอย่าง PDF</Button>}
        </aside>}
        <section className={`receipt-print-preview${isMobile && pdfPreviewKind === 'receipt' && mobilePrintTab !== 'preview' ? ' receipt-print-mobile-hidden' : ''}`}>
          <div className="receipt-print-preview-heading">
            <div>
              <span className="receipt-print-eyebrow">DOCUMENT PREVIEW</span>
              <h3>ตัวอย่างเอกสาร</h3>
            </div>
            <Tag color={pdfLoading ? 'processing' : pdfDataUrl ? 'success' : 'default'}>
              {pdfLoading ? 'กำลังสร้างตัวอย่าง' : pdfDataUrl ? 'พร้อมดาวน์โหลด' : 'รอตัวอย่าง'}
            </Tag>
          </div>
          {isMobile && pdfDataUrl && <Button size="small" className="receipt-print-open-pdf" onClick={handleOpenPdf}>
            เปิดไฟล์ PDF ในแอปอื่น
          </Button>}
          <div className="receipt-print-preview-canvas">
          {pdfLoading && (
          <div className="receipt-print-preview-state">
            <Spin size="large" />
            <Text type="secondary">กำลังจัดหน้าเอกสาร...</Text>
          </div>
          )}
          {!pdfLoading && pdfDataUrl && (
            isMobile
              ? (pdfPreviewKind === 'table' || mobilePrintTab === 'preview'
                  ? <MobilePdfPreview dataUrl={pdfDataUrl} openPdf={handleOpenPdf} />
                  : null)
              : <iframe
                  key={`${printType}-${pdfDataUrl.length}`}
                  src={pdfObjectUrl || pdfDataUrl}
                  className="receipt-print-preview-frame"
                  title="ตัวอย่างเอกสาร"
                />
          )}
          {!pdfLoading && !pdfDataUrl && <div className="receipt-print-preview-state"><Empty description="ยังไม่มีตัวอย่างเอกสาร" /></div>}
          </div>
        </section>
        </div>
      </Modal>

      <div className="receipts-page-heading" style={{ marginBottom: isMobile ? 12 : 24 }}>
        <Title level={2} className="receipts-page-title">
          <FileTextOutlined style={{ marginRight: '12px', color: '#1890ff' }} />
          {isMobile ? 'ใบเสร็จ/ใบแจ้งหนี้' : 'จัดการใบเสร็จ/ใบแจ้งหนี้ (พร้อมการคำนวณภาษี)'}
        </Title>
      </div>

      {isMobile && <Button className="mobile-receipt-primary-cta" type="primary" block size="large" icon={<PlusOutlined />} onClick={showCreateModal}>สร้างใบเสร็จใหม่ (ขาย)</Button>}

      {/* Sales Statistics */}
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={12} sm={12} md={6}>
          <Card size={isMobile ? "small" : "default"}>
            <Statistic
              title={`ยอดขายรวม (${salesPeriodLabel})`}
              value={salesStats.total_sales || 0}
              precision={2}
              valueStyle={{
                color: '#3f8600',
                fontSize: isMobile ? '16px' : '24px'
              }}
              prefix={<DollarOutlined />}
              suffix="บาท"
            />
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Card size={isMobile ? "small" : "default"}>
            <Statistic
              title="ใบเสร็จทั้งหมด"
              value={salesStats.total_receipts || 0}
              valueStyle={{
                color: '#1890ff',
                fontSize: isMobile ? '16px' : '24px'
              }}
              prefix={<FileTextOutlined />}
            />
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Card size={isMobile ? "small" : "default"}>
            <Statistic
              title="ชำระแล้ว"
              value={salesStats.paid_receipts || 0}
              valueStyle={{
                color: '#52c41a',
                fontSize: isMobile ? '16px' : '24px'
              }}
              prefix={<MoneyCollectOutlined />}
            />
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Card size={isMobile ? "small" : "default"}>
            <Statistic
              title="ค้างชำระ"
              value={salesStats.outstanding_amount || 0}
              precision={2}
              valueStyle={{
                color: '#cf1322',
                fontSize: isMobile ? '16px' : '24px'
              }}
              prefix={<CalendarOutlined />}
              suffix="บาท"
            />
          </Card>
        </Col>
      </Row>

      <Card size="small" style={{ marginBottom: 16 }} title="กระทบยอดรายได้ตามตัวกรอง (ข้อมูลทุกหน้า)">
        <Row gutter={[16, 12]}>
          <Col xs={12} md={6}><Statistic title="รายได้ก่อน VAT" value={salesStats.revenue_before_vat || 0} precision={2} suffix="บาท" /></Col>
          <Col xs={12} md={6}><Statistic title="ภาษีขาย" value={salesStats.output_vat || 0} precision={2} suffix="บาท" /></Col>
          <Col xs={12} md={6}><Statistic title="ยอดเอกสารที่ลงบัญชีแล้ว" value={salesStats.posted_document_total || 0} precision={2} suffix="บาท" valueStyle={{ color: '#3f8600' }} /></Col>
          <Col xs={12} md={6}><Statistic title="ยอดเอกสารที่ยังไม่ลงบัญชี" value={salesStats.unposted_document_total || 0} precision={2} suffix="บาท" valueStyle={{ color: '#fa8c16' }} /></Col>
        </Row>
      </Card>

      {/* Desktop Status Filter Badges */}
      {!isMobile && (
        <Card style={{ marginBottom: '16px' }}>
          <Space size="large" wrap>
            <Badge
              count={statusCounts.find(s => s.status === 'invoice')?.count || 0}
              color="blue"
            >
              <Button
                type={filters.status === 'invoice' ? 'primary' : 'default'}
                onClick={() => handleStatusFilter(filters.status === 'invoice' ? '' : 'invoice')}
              >
                ใบแจ้งหนี้
              </Button>
            </Badge>

            <Badge
              count={statusCounts.find(s => s.status === 'paid')?.count || 0}
              color="green"
            >
              <Button
                type={filters.status === 'paid' ? 'primary' : 'default'}
                onClick={() => handleStatusFilter(filters.status === 'paid' ? '' : 'paid')}
              >
                ชำระแล้ว
              </Button>
            </Badge>

            <Badge
              count={statusCounts.find(s => s.status === 'partial')?.count || 0}
              color="orange"
            >
              <Button
                type={filters.status === 'partial' ? 'primary' : 'default'}
                onClick={() => handleStatusFilter(filters.status === 'partial' ? '' : 'partial')}
              >
                ชำระบางส่วน
              </Button>
            </Badge>

            <Badge
              count={statusCounts.find(s => s.status === 'overdue')?.count || 0}
              color="red"
            >
              <Button
                type={filters.status === 'overdue' ? 'primary' : 'default'}
                onClick={() => handleStatusFilter(filters.status === 'overdue' ? '' : 'overdue')}
              >
                เกินกำหนด
              </Button>
            </Badge>
          </Space>
        </Card>
      )}

      {/* Desktop Search and Filters */}
      {!isMobile && (
        <Card style={{ marginBottom: '16px' }}>
          <Row gutter={16}>
            <Col span={24} style={{ marginBottom: 16 }}>
              <Space wrap>
                <Text strong>
                  <CalendarOutlined /> กรองตามช่วงเวลา:
                </Text>
                <Button
                  size="small"
                  type={selectedQuickFilter === 'all' ? 'primary' : 'default'}
                  onClick={() => handleQuickDateFilter('all')}
                >
                  ทั้งหมด
                </Button>
                <Button
                  size="small"
                  type={selectedQuickFilter === 'this_month' ? 'primary' : 'default'}
                  onClick={() => handleQuickDateFilter('this_month')}
                >
                  เดือนนี้
                </Button>
                <Button
                  size="small"
                  type={selectedQuickFilter === 'last_month' ? 'primary' : 'default'}
                  onClick={() => handleQuickDateFilter('last_month')}
                >
                  เดือนที่แล้ว
                </Button>
                <Button
                  size="small"
                  type={selectedQuickFilter === 'last_3_months' ? 'primary' : 'default'}
                  onClick={() => handleQuickDateFilter('last_3_months')}
                >
                  รอบ 3 เดือน
                </Button>
                <Button
                  size="small"
                  type={selectedQuickFilter === 'last_6_months' ? 'primary' : 'default'}
                  onClick={() => handleQuickDateFilter('last_6_months')}
                >
                  รอบ 6 เดือน
                </Button>
                <RangePicker
                  value={selectedDateRange}
                  onChange={handleDateRangeChange}
                  placeholder={['วันเริ่มต้น', 'วันสิ้นสุด']}
                  format="DD/MM/YYYY"
                  style={{ width: 240 }}
                />
                {(selectedDateRange[0] || selectedDateRange[1]) && (
                  <Button
                    size="small"
                    type="link"
                    onClick={clearDateFilter}
                    danger
                  >
                    ล้างตัวกรอง
                  </Button>
                )}
              </Space>
            </Col>
            <Col span={3}>
              <Input.Search
                placeholder="ค้นหาเลขที่เอกสาร, ลูกค้า"
                allowClear
                onSearch={handleSearch}
                style={{ width: '100%' }}
              />
            </Col>
            <Col span={4}>
              <Select
                placeholder="เลือกสถานะ"
                allowClear
                style={{ width: '100%' }}
                value={filters.status}
                onChange={handleStatusFilter}
              >
                {statusOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col span={6}>
              <Select
                placeholder="เลือกลูกค้า"
                allowClear
                showSearch
                optionFilterProp="children"
                style={{ width: '100%' }}
                value={filters.contact_id}
                onChange={handleCustomerFilter}
              >
                {customers.map(customer => (
                  <Option key={customer.id} value={customer.id}>
                    {customer.name}{customer.company_name && ` (${customer.company_name})`}
                  </Option>
                ))}
              </Select>
            </Col>



            <>
              <Col span={4}>
                <Space>
                  <Button onClick={clearFilters}>ล้าง</Button>
                  <Button
                    icon={<PrinterOutlined />}
                    onClick={handlePrintTable}
                  >
                    พิมพ์ตาราง
                  </Button>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={showCreateModal}
                  >
                    สร้างใบเสร็จ
                  </Button>
                </Space>
              </Col>
            </>



          </Row>
        </Card>
      )}

      {/* Mobile Search and Status Filters */}
      {isMobile && (
        <>
          <Card style={{ marginBottom: '16px' }}>
            <Input
              placeholder="ค้นหาเลขที่เอกสาร, ลูกค้า"
              prefix={<SearchOutlined />}
              value={filters.search}
              onChange={(e) => handleSearch(e.target.value)}
              allowClear
            />
            <div style={{ marginTop: '12px', textAlign: 'center' }}>
              <Space wrap>
                <Button
                  icon={<FilterOutlined />}
                  onClick={() => setMobileFiltersVisible(true)}
                  size="small"
                >
                  ตัวกรอง
                </Button>
                <Badge
                  count={statusCounts.find(s => s.status === 'invoice')?.count || 0}
                  color="blue"
                  size="small"
                >
                  <Button
                    type={filters.status === 'invoice' ? 'primary' : 'default'}
                    onClick={() => handleStatusFilter(filters.status === 'invoice' ? '' : 'invoice')}
                    size="small"
                  >
                    ใบแจ้งหนี้
                  </Button>
                </Badge>
                <Badge
                  count={statusCounts.find(s => s.status === 'paid')?.count || 0}
                  color="green"
                  size="small"
                >
                  <Button
                    type={filters.status === 'paid' ? 'primary' : 'default'}
                    onClick={() => handleStatusFilter(filters.status === 'paid' ? '' : 'paid')}
                    size="small"
                  >
                    ชำระแล้ว
                  </Button>
                </Badge>
              </Space>
            </div>
          </Card>

          {/* Mobile Filters Drawer */}
          <Drawer
            title="ตัวกรองข้อมูล"
            placement="bottom"
            height="auto"
            open={mobileFiltersVisible}
            onClose={() => setMobileFiltersVisible(false)}
          >
            <div style={{ padding: '16px 0' }}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>ช่วงเวลา</label>
                <Space wrap size={8} style={{ marginBottom: 12 }}>
                  {[
                    ['all', 'ทั้งหมด'],
                    ['this_month', 'เดือนนี้'],
                    ['last_month', 'เดือนที่แล้ว'],
                    ['last_3_months', 'รอบ 3 เดือน'],
                    ['last_6_months', 'รอบ 6 เดือน']
                  ].map(([key, label]) => (
                    <Button key={key} size="small" type={selectedQuickFilter === key ? 'primary' : 'default'}
                      onClick={() => handleQuickDateFilter(key)}>{label}</Button>
                  ))}
                </Space>
                <RangePicker value={selectedDateRange} onChange={handleDateRangeChange}
                  placeholder={['วันเริ่มต้น', 'วันสิ้นสุด']} format="DD/MM/YYYY"
                  style={{ width: '100%' }} />
              </div>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>สถานะ</label>
                <Select
                  placeholder="เลือกสถานะ"
                  value={filters.status}
                  onChange={handleStatusFilter}
                  allowClear
                  style={{ width: '100%' }}
                >
                  {statusOptions.map(option => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>ลูกค้า</label>
                <Select
                  placeholder="เลือกลูกค้า"
                  value={filters.contact_id}
                  onChange={handleCustomerFilter}
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                >
                  {customers.map(customer => (
                    <Option key={customer.id} value={customer.id}>
                      {customer.name} {customer.company_name && `(${customer.company_name})`}
                    </Option>
                  ))}
                </Select>
              </div>

              <div style={{ textAlign: 'center', paddingTop: '16px' }}>
                <Space>
                  <Button onClick={clearFilters}>ล้างตัวกรอง</Button>
                  <Button
                    type="primary"
                    onClick={() => setMobileFiltersVisible(false)}
                  >
                    ตกลง
                  </Button>
                </Space>
              </div>
            </div>
          </Drawer>
        </>
      )}

      {/* Data Display */}
      <Card style={{ minWidth: 0 }}>
        {isMobile ? (
          <List
            loading={loading}
            dataSource={receipts}
            renderItem={(receipt) => <ReceiptCard key={receipt.id} receipt={receipt} />}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              onChange: (page, pageSize) => {
                setPagination(prev => ({ ...prev, current: page, pageSize }));
              },
              showSizeChanger: false,
              showQuickJumper: false,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} จาก ${total} รายการ`,
              size: 'small'
            }}
          />
        ) : (
          <Table
            columns={columns}
            tableLayout="fixed"
            dataSource={receipts}
            rowKey="id"
            loading={loading}
            pagination={{
              ...pagination,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} จาก ${total} รายการ`,
            }}
            onChange={handleTableChange}
            scroll={{ x: 'max-content' }}

            footer={() => {

              const totalAmount = receipts.reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
              const totalTax = receipts.reduce((sum, item) => sum + parseFloat(item.tax_amount || 0), 0)

              return (
                <div style={{
                  padding: '8px 16px',
                  background: '#f5f5f5',
                  borderRadius: '4px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: 18
                }}>
                  <div>
                    <Text strong>ยอดรวมทั้งสิ้น:</Text>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div><Text strong>จำนวนเงิน:</Text> {totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</div>
                    <div><Text strong>ภาษีขาย:</Text> {totalTax.toLocaleString(undefined, { minimumFractionDigits: 2 })}</div>
                  </div>
                </div>
              )
            }}

          />
        )}
      </Card>

      {/* Float Button for Mobile Add */}
      {isMobile && (
        <FloatButton
          icon={<PlusOutlined />}
          type="primary"
          onClick={showCreateModal}
          style={{ right: 20, bottom: 'calc(82px + env(safe-area-inset-bottom))' }}
          tooltip="สร้างใบเสร็จใหม่ (ขาย)"
        />
      )}

      {/* Create/Edit Receipt Form */}
      {isMobile ? (
        <Drawer
          title={editingReceipt ? 'แก้ไขใบเสร็จ' : 'สร้างใบเสร็จใหม่'}
          open={modalVisible}
          onClose={handleCloseModal}
          width="100%"
          placement="right"
          destroyOnClose
          extra={
            <Space>
              <Button onClick={handleCloseModal}>ยกเลิก</Button>
              <Button
                type="primary"
                onClick={() => form.submit()}
                loading={loading}
              >
                บันทึก
              </Button>
            </Space>
          }
        >
          <ReceiptForm
            form={form}
            customers={customers}
            products={products}
            onSubmit={handleSubmit}
            onCancel={handleCloseModal}
            loading={loading}
            isEditing={!!editingReceipt}
            editingReceipt={editingReceipt}
            isMobile={isMobile}
            barcodeMode={barcodeMode}
            setBarcodeMode={setBarcodeMode}
            barcodeInput={barcodeInput}
            setBarcodeInput={setBarcodeInput}
            barcodeLoading={barcodeLoading}
            barcodeInputRef={barcodeInputRef}
            handleBarcodeScanned={handleBarcodeScanned}
            handleBarcodeInputChange={handleBarcodeInputChange}
            handleBarcodeInputKeyPress={handleBarcodeInputKeyPress}
            clearBarcodeInput={clearBarcodeInput}
            vatModeOptions={vatModeOptions || []}
            calculateTotals={calculateTotals}
            canCreateCustomer={canCreateCustomer}
            onAddCustomer={handleOpenCustomerModal}
          />
        </Drawer>
      ) : (
        <Modal
          title={editingReceipt ? 'แก้ไขใบเสร็จ' : 'สร้างใบเสร็จใหม่'}
          open={modalVisible}
          onCancel={handleCloseModal}
          footer={null}
          width={900}
          destroyOnClose
        >
          <ReceiptForm
            form={form}
            customers={customers}
            products={products}
            onSubmit={handleSubmit}
            onCancel={handleCloseModal}
            loading={loading}
            isEditing={!!editingReceipt}
            editingReceipt={editingReceipt}
            isMobile={isMobile}
            barcodeMode={barcodeMode}
            setBarcodeMode={setBarcodeMode}
            barcodeInput={barcodeInput}
            setBarcodeInput={setBarcodeInput}
            barcodeLoading={barcodeLoading}
            barcodeInputRef={barcodeInputRef}
            onValuesChange={handleFormChange}
            handleBarcodeScanned={handleBarcodeScanned}
            handleBarcodeInputChange={handleBarcodeInputChange}
            handleBarcodeInputKeyPress={handleBarcodeInputKeyPress}
            clearBarcodeInput={clearBarcodeInput}
            vatModeOptions={vatModeOptions || []}
            calculateTotals={calculateTotals}
            canCreateCustomer={canCreateCustomer}
            onAddCustomer={handleOpenCustomerModal}
          />
        </Modal>
      )}

      <Modal
        title="เพิ่มลูกค้าใหม่"
        open={customerModalVisible}
        onOk={handleCreateCustomer}
        onCancel={() => {
          setCustomerModalVisible(false);
          customerForm.resetFields();
        }}
        okText="บันทึกและเลือกลูกค้า"
        cancelText="ยกเลิก"
        confirmLoading={customerSaving}
        width={isMobile ? 'calc(100% - 24px)' : 680}
        zIndex={1400}
        styles={{ body: { maxHeight: 'calc(100vh - 190px)', overflowY: 'auto' } }}
        destroyOnClose
      >
        <Form form={customerForm} layout="vertical" preserve={false}>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="name"
                label="ชื่อลูกค้า"
                rules={[{ required: true, whitespace: true, message: 'กรุณาระบุชื่อลูกค้า' }]}
              >
                <Input placeholder="ชื่อบุคคลหรือชื่อที่ใช้ติดต่อ" autoFocus />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name="company_name" label="ชื่อบริษัท/ร้านค้า">
                <Input placeholder="ชื่อที่จดทะเบียน (ถ้ามี)" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item name="contact_person" label="ผู้ติดต่อ">
                <Input placeholder="ชื่อผู้ประสานงาน" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name="tax_id" label="เลขประจำตัวผู้เสียภาษี">
                <Input placeholder="เลขประจำตัวผู้เสียภาษี 13 หลัก" maxLength={20} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item name="phone" label="เบอร์โทรศัพท์">
                <Input placeholder="เบอร์โทรศัพท์" maxLength={30} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="email"
                label="อีเมล"
                rules={[{ type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง' }]}
              >
                <Input placeholder="example@company.com" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item name="address" label="ที่อยู่สำหรับออกเอกสาร">
            <Input.TextArea rows={3} placeholder="บ้านเลขที่ ถนน ตำบล/แขวง อำเภอ/เขต จังหวัด" />
          </Form.Item>
          <Form.Item name="postal_code" label="รหัสไปรษณีย์">
            <Input placeholder="รหัสไปรษณีย์" maxLength={10} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Payment Modal */}
      <Modal
        title="บันทึกการชำระเงิน"
        open={paymentModalVisible}
        onCancel={handleClosePaymentModal}
        footer={null}
        width={isMobile ? '100%' : 500}
      >
        <PaymentForm
          form={paymentForm}
          receipt={paymentReceipt}
          paymentMethods={paymentMethods}
          onSubmit={handlePayment}
          onCancel={handleClosePaymentModal}
          loading={loading}
          isMobile={isMobile}
        />
      </Modal>

      {/* Receipt Detail Drawer */}
      <Drawer
        title="รายละเอียดใบเสร็จ"
        placement="right"
        size={isMobile ? "default" : "large"}
        open={detailDrawerVisible}
        onClose={() => setDetailDrawerVisible(false)}
        width={isMobile ? "100%" : undefined}
      >
        {selectedReceipt && <ReceiptDetail receipt={selectedReceipt} isMobile={isMobile} vatModeOptions={vatModeOptions || []} />}
      </Drawer>
    </div>
  );
};

// Receipt Form Component with VAT Calculation
const ReceiptForm = ({
  form,
  customers,
  products,
  onSubmit,
  onCancel,
  loading,
  isEditing,
  editingReceipt,
  isMobile,
  barcodeMode,
  setBarcodeMode,
  barcodeInput,
  setBarcodeInput,
  barcodeLoading,
  barcodeInputRef,
  handleBarcodeScanned,
  handleBarcodeInputChange,
  handleBarcodeInputKeyPress,
  clearBarcodeInput,
  vatModeOptions,
  calculateTotals,
  canCreateCustomer,
  onAddCustomer
}) => {


  // Status options
  const statusOptions = [
    { value: 'invoice', label: 'ใบแจ้งหนี้', color: 'processing' },
    { value: 'paid', label: 'ชำระแล้ว', color: 'success' },
    { value: 'partial', label: 'ชำระบางส่วน', color: 'warning' },
    { value: 'overdue', label: 'เกินกำหนด', color: 'error' },
    { value: 'cancelled', label: 'ยกเลิก', color: 'default' },
  ];


  const [calcValues, setCalcValues] = useState({
    subtotal: 0,
    discount: 0,
    subtotalAfterDiscount: 0,
    taxAmount: 0,
    totalAmount: 0
  });

  // Update calculations when form values change
  const updateCalculations = () => {
    const items = form.getFieldValue('items') || [];
    const discount = form.getFieldValue('discount') || 0;
    const taxRate = form.getFieldValue('tax_rate') || 0;
    const vatMode = form.getFieldValue('vat_mode') || 'exclude';

    const calculations = calculateTotals(items, discount, taxRate, vatMode);
    setCalcValues(calculations);
  };


  const handleFormChange = () => {
    const items = form.getFieldValue('items') || [];
    const discount = form.getFieldValue('discount') || 0;
    const taxRate = form.getFieldValue('tax_rate') || 7;
    const currentVatMode = form.getFieldValue('vat_mode') || 'exclude';

    const calculations = calculateTotals(items, discount, taxRate, currentVatMode);
    setCalcValues(calculations);

  };


  // โหลดข้อมูลครั้งแรก
  useEffect(() => {
    updateCalculations();
    //console.log('calcValues', calcValues)
  }, [calcValues]);




  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onSubmit}
      onValuesChange={handleFormChange} // ⬅️ ตรงนี้
      initialValues={{
        receipt_date: dayjs(),
        tax_rate: 7,
        vat_mode: 'include',
        discount: 0,
        items: [{ description: '-', quantity: 1, unit_price: 0, is_free: false }]
      }}
    >
      <Row gutter={isMobile ? [0, 16] : 16}>

        {isEditing && (
          <>
            <Col xs={24} sm={12}>
              <Form.Item
                name="invoice_number"
                label="เลขที่ใบแจ้งหนี้"
                rules={[{ required: true, message: 'หมายเลขเอกสาร' }]}
              >
                <Input style={{ width: '100%' }} disabled={Boolean(editingReceipt?.receipt_number || Number(editingReceipt?.paid_amount) > 0)} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item noStyle shouldUpdate={(previous, current) => previous.invoice_number !== current.invoice_number}>
                {({ getFieldValue }) => <Form.Item label="เลขที่ใบเสร็จ" extra="ระบบใช้เลขนี้เมื่อรับชำระครบ">
                  <Input
                    value={editingReceipt?.receipt_number || String(getFieldValue('invoice_number') || '').replace(/^INV/i, 'REC')}
                    readOnly
                  />
                </Form.Item>}
              </Form.Item>
            </Col>
          </>
        )}

        <Col xs={24} sm={12}>
          <Form.Item
            name="contact_id"
            label={(
              <Space size={6}>
                <span>ลูกค้า</span>
                {canCreateCustomer && (
                  <Tooltip title="เพิ่มลูกค้าใหม่โดยไม่ต้องออกจากใบเสร็จ">
                    <Button
                      type="link"
                      size="small"
                      htmlType="button"
                      icon={<PlusOutlined />}
                      onClick={onAddCustomer}
                      style={{ height: 'auto', padding: 0 }}
                    >
                      เพิ่มลูกค้า
                    </Button>
                  </Tooltip>
                )}
              </Space>
            )}
            rules={[{ required: true, message: 'กรุณาเลือกลูกค้า' }]}
          >
            <Select
              placeholder="เลือกลูกค้า"
              showSearch
              optionFilterProp="children"
              style={{ width: '100%' }}
            >
              {customers.map(customer => (
                <Option key={customer.id} value={customer.id}>
                  {customer.name} {customer.company_name && `(${customer.company_name})`}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="receipt_date"
            label="วันที่"
            rules={[{ required: true, message: 'กรุณาเลือกวันที่' }]}
          >
            <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={isMobile ? [0, 16] : 16}>
        <Col xs={24} sm={isEditing ? 12 : 24}>
          <Form.Item
            name="due_date"
            label="กำหนดชำระ"
          >
            <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
          </Form.Item>
        </Col>
        {isEditing && (
          <Col xs={24} sm={12}>
            <Form.Item
              name="status"
              label="สถานะ"
            >
              <Select placeholder="เลือกสถานะ" disabled={['paid', 'partial'].includes(editingReceipt?.status)}>
                {statusOptions.filter(option => !['paid', 'partial'].includes(option.value) || option.value === editingReceipt?.status).map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
      </Row>

      <Divider>รายการสินค้า/บริการ</Divider>

      {/* Barcode Scanner Section */}
      <Card style={{ marginBottom: 16, backgroundColor: '#f8f9fa' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <BarcodeOutlined style={{ marginRight: 8, color: '#1890ff' }} />
            <span style={{ fontWeight: 'bold', color: '#1890ff' }}>สแกนบาร์โค้ด</span>
          </div>
          <Switch
            checked={barcodeMode}
            onChange={setBarcodeMode}
            checkedChildren={<ScanOutlined />}
            unCheckedChildren="OFF"
          />
        </div>

        {barcodeMode && (
          <>
            <Alert
              message="สแกนบาร์โค้ดหรือพิมพ์รหัสบาร์โค้ดแล้วกด Enter"
              type="info"
              showIcon
              style={{ marginBottom: 12 }}
            />
            <div style={{ display: 'flex', gap: 8 }}>
              <Input
                ref={barcodeInputRef}
                placeholder="สแกนหรือพิมพ์บาร์โค้ด..."
                value={barcodeInput}
                onChange={handleBarcodeInputChange}
                onPressEnter={handleBarcodeInputKeyPress}
                prefix={<BarcodeOutlined />}
                suffix={
                  barcodeLoading ? (
                    <div className="loading-spinner" />
                  ) : barcodeInput ? (
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      size="small"
                      onClick={clearBarcodeInput}
                    />
                  ) : undefined
                }
                style={{ flex: 1 }}
                autoFocus={barcodeMode}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => handleBarcodeScanned(barcodeInput)}
                disabled={!barcodeInput.trim() || barcodeLoading}
                loading={barcodeLoading}
              >
                ค้นหา
              </Button>
            </div>
          </>
        )}
      </Card>

      <Form.List name="items">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Card key={key} style={{ marginBottom: 16 }} size="small">
                <Row gutter={isMobile ? [0, 12] : 16}>
                  <Col xs={24} sm={6}>
                    <Form.Item
                      {...restField}
                      name={[name, 'product_id']}
                      label="สินค้า"
                    >
                      <Select
                        placeholder="เลือกสินค้า"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        onChange={(value) => {
                          if (value) {
                            const product = products.find(p => p.id === value);
                            if (product) {
                              const items = form.getFieldValue('items');
                              const defaultUnit = (product.units || []).find(unit => unit.is_default_sale)
                                || (product.units || []).find(unit => unit.is_base)
                                || (product.units || [])[0];
                              items[name] = {
                                ...items[name],
                                description: product.name,
                                product_unit_id: defaultUnit?.id,
                                unit_price: defaultUnit?.sale_price ?? product.price
                              };
                              form.setFieldsValue({ items });
                            }
                          }
                        }}
                      >
                        {products.map(product => (
                          <Option key={product.id} value={product.id}>
                            {product.name} - ฿{product.price}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={6}>
                    <Form.Item noStyle shouldUpdate={(previous, current) => previous.items?.[name]?.product_id !== current.items?.[name]?.product_id}>
                      {({ getFieldValue }) => {
                        const productId = getFieldValue(['items', name, 'product_id']);
                        const product = products.find(row => Number(row.id) === Number(productId));
                        return <Form.Item {...restField} name={[name, 'product_unit_id']} label="หน่วยขาย">
                          <Select allowClear={!productId} placeholder="หน่วยฐาน" disabled={!productId}
                            options={(product?.units || []).map(unit => ({
                              value: unit.id,
                              label: `${unit.unit_name} (${Number(unit.conversion_to_base)} หน่วยฐาน)`
                            }))}
                            onChange={unitId => {
                              const unit = (product?.units || []).find(row => Number(row.id) === Number(unitId));
                              if (unit?.sale_price !== null && unit?.sale_price !== undefined) {
                                const items = [...(form.getFieldValue('items') || [])];
                                items[name] = { ...items[name], product_unit_id: unitId, unit_price: Number(unit.sale_price) };
                                form.setFieldsValue({ items });
                              }
                            }} />
                        </Form.Item>;
                      }}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      {...restField}
                      name={[name, 'description']}
                      label="รายการ"
                      rules={[{ required: true, message: 'กรุณากรอกรายการ' }]}
                    >
                      <Input placeholder="รายละเอียดสินค้า/บริการ" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={isMobile ? [0, 12] : 16}>
                  <Col xs={12} sm={3}>
                    <Form.Item
                      {...restField}
                      name={[name, 'quantity']}
                      label="จำนวน"
                      rules={[{ required: true, message: 'กรุณากรอกจำนวน' }]}
                    >
                      <InputNumber
                        min={0.01}
                        step={0.01}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={3}>
                    <Form.Item {...restField} name={[name, 'width_m']} label="กว้าง (ม.)"><InputNumber min={0.001} step={0.01} style={{ width: '100%' }} /></Form.Item>
                  </Col>
                  <Col xs={12} sm={3}>
                    <Form.Item {...restField} name={[name, 'height_m']} label="สูง/ยาว (ม.)"><InputNumber min={0.001} step={0.01} style={{ width: '100%' }} /></Form.Item>
                  </Col>
                  <Col xs={12} sm={4}>
                    <Form.Item
                      {...restField}
                      name={[name, 'unit_price']}
                      label="ราคาต่อหน่วย"
                      rules={[{ required: true, message: 'กรุณากรอกราคา' }]}
                    >
                      <InputNumber
                        min={0}
                        step={0.01}
                        style={{ width: '100%' }}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={4}>
                    <Form.Item label="รวม" shouldUpdate={(prevValues, currentValues) => {
                      const prevItems = prevValues.items || [];
                      const currentItems = currentValues.items || [];
                      return JSON.stringify(prevItems) !== JSON.stringify(currentItems);
                    }}>
                      {({ getFieldValue }) => {
                        const items = getFieldValue('items') || [];
                        const item = items[name] || {};
                        const total = item.is_free ? 0 : (item.quantity || 0) * (item.unit_price || 0);
                        return (
                          <InputNumber
                            value={total}
                            disabled
                            style={{ width: '100%' }}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          />
                        );
                      }}
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={5}>
                    <Form.Item {...restField} name={[name, 'is_free']} label="ของแถม" valuePropName="checked">
                      <Switch checkedChildren={<><GiftOutlined /> ฟรี</>} unCheckedChildren="คิดเงิน" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={2}>
                    <Form.Item label={isMobile ? "ลบ" : " "}>
                      <Button
                        type="text"
                        danger
                        onClick={() => remove(name)}
                        disabled={fields.length === 1}
                        style={{ width: '100%' }}
                      >
                        ลบ
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            ))}
            <Button
              type="dashed"
              onClick={() => add({ description: '', quantity: 1, unit_price: 0, is_free: false })}
              block
              icon={<PlusOutlined />}
            >
              เพิ่มรายการ
            </Button>
          </>
        )}
      </Form.List>

      <Divider>ข้อมูลเพิ่มเติม</Divider>

      <Row gutter={isMobile ? [0, 16] : 16}>
        <Col xs={24} sm={12}>
          <Form.Item
            name="discount"
            label="ส่วนลด"
          >
            <InputNumber
              min={0}
              step={0.01}
              style={{ width: '100%' }}
              onChange={handleFormChange}
              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
              addonAfter="บาท"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="tax_rate"
            label="อัตราภาษี (%)"
          >
            <InputNumber
              min={0}
              max={100}
              step={0.01}
              style={{ width: '100%' }}
              onChange={handleFormChange}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* VAT Mode Selection */}
      <Card style={{ marginBottom: 16 }}>
        <Divider>การคำนวณภาษี</Divider>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <Form.Item
              name="vat_mode"
              label="โหมดการคำนวณภาษี"
              rules={[{ required: true, message: 'กรุณาเลือกโหมดการคำนวณภาษี' }]}
            >
              <Radio.Group
                size={isMobile ? "small" : "default"}
                onChange={handleFormChange}
              >
                <Radio.Button value="no_tax">ไม่มีภาษี</Radio.Button>
                <Radio.Button value="exclude">แยกภาษี (VAT EXCLUDE)</Radio.Button>
                <Radio.Button value="include">รวมภาษี (VAT INCLUDE)</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Alert
              message={
                form.getFieldValue('vat_mode') === 'include'
                  ? "โหมด VAT INCLUDE: ราคาสินค้าที่ป้อนรวมภาษีแล้ว ระบบจะแยกคำนวณภาษีออกจากยอดรวม"
                  : form.getFieldValue('vat_mode') === 'exclude'
                    ? "โหมด VAT EXCLUDE: ราคาสินค้าที่ป้อนยังไม่รวมภาษี ระบบจะคำนวณภาษีเพิ่มเติม"
                    : "โหมดไม่มีภาษี: ระบบจะไม่คำนวณภาษีให้"
              }
              type={
                form.getFieldValue('vat_mode') === 'include'
                  ? 'info'
                  : form.getFieldValue('vat_mode') === 'exclude'
                    ? 'warning'
                    : 'info' // ✅ เปลี่ยนจาก default → info
              }
              showIcon
            />
          </Col>
        </Row>
      </Card>

      {/* Calculation Summary */}
      {(
        <>
          <Card title="สรุปการคำนวณ" size="small" style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={12}><strong>ยอดรวมก่อนภาษี:</strong></Col>
              <Col span={12} style={{ textAlign: 'right' }}>{calcValues.subtotal?.toLocaleString()}</Col>

              <Col span={12}><strong>ส่วนลด:</strong></Col>
              <Col span={12} style={{ textAlign: 'right' }}>{calcValues.discount?.toLocaleString()}</Col>

              <Col span={12}><strong>ยอดหลังส่วนลด:</strong></Col>
              <Col span={12} style={{ textAlign: 'right' }}>{calcValues.subtotalAfterDiscount?.toLocaleString()}</Col>

              <Col span={12}><strong>ภาษีมูลค่าเพิ่ม:</strong></Col>
              <Col span={12} style={{ textAlign: 'right' }}>{calcValues.taxAmount?.toLocaleString()}</Col>

              <Divider style={{ margin: '8px 0' }} />

              <Col span={12}><strong>ยอดรวมทั้งสิ้น:</strong></Col>
              <Col span={12} style={{ textAlign: 'right', fontSize: '16px', fontWeight: 'bold', color: '#1890ff' }}>
                {calcValues.totalAmount?.toLocaleString()}
              </Col>
            </Row>
          </Card>
        </>
      )}

      <Form.Item
        name="notes"
        label="หมายเหตุ"
      >
        <TextArea rows={3} placeholder="หมายเหตุเพิ่มเติม" />
      </Form.Item>

      {!isMobile && (
        <Form.Item>
          <Space>
            <Button onClick={onCancel}>
              ยกเลิก
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              บันทึก
            </Button>
          </Space>
        </Form.Item>
      )}
    </Form>
  );
};

// Payment Form Component
const PaymentForm = ({ form, receipt, paymentMethods, onSubmit, onCancel, loading, isMobile }) => {
  if (!receipt) return null;

  const remainingAmount = receipt.total_amount - (receipt.paid_amount || 0);

  return (
    <div>
      <Descriptions column={1} bordered style={{ marginBottom: 16 }} size={isMobile ? "small" : "default"}>
        <Descriptions.Item label="เลขที่เอกสาร">
          {receipt.invoice_number}
        </Descriptions.Item>
        <Descriptions.Item label="ลูกค้า">
          {receipt.contact_name}
        </Descriptions.Item>
        <Descriptions.Item label="ยอดรวม">
          ฿{parseFloat(receipt.total_amount).toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label="ชำระแล้ว">
          ฿{parseFloat(receipt.paid_amount || 0).toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label="คงเหลือ">
          <strong style={{ color: '#cf1322' }}>
            ฿{remainingAmount.toLocaleString()}
          </strong>
        </Descriptions.Item>
      </Descriptions>

      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        initialValues={{ payment_date: dayjs(receipt.receipt_date) }}
      >
        <Form.Item
          name="paid_amount"
          label="จำนวนเงินที่ชำระ"
          rules={[
            { required: true, message: 'กรุณากรอกจำนวนเงิน' },
            {
              validator: (_, value) => {
                if (value > remainingAmount) {
                  return Promise.reject('จำนวนเงินที่ชำระต้องไม่เกินยอดคงเหลือ');
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <InputNumber
            min={0}
            max={remainingAmount}
            step={0.01}
            style={{ width: '100%' }}
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
            addonAfter="บาท"
          />
        </Form.Item>

        <Form.Item
          name="payment_method"
          label="วิธีการชำระเงิน"
          rules={[{ required: true, message: 'กรุณาเลือกวิธีการชำระเงิน' }]}
        >
          <Select placeholder="เลือกวิธีการชำระเงิน">
            {paymentMethods.map(method => (
              <Option key={method} value={method}>
                {method}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="payment_date"
          label="วันที่ชำระเงิน"
          rules={[{ required: true, message: 'กรุณาเลือกวันที่ชำระเงิน' }]}
        >
          <DatePicker
            style={{ width: '100%' }}
            format="DD-MM-YYYY" // แสดงและส่งฟอร์แมต DD-MM-YYYY
          />
        </Form.Item>

        <Form.Item
          name="reference_no"
          label="เลขที่อ้างอิงการชำระเงิน"
        >
          <Input placeholder="เช่น เลขที่รายการโอน หรือเลขที่เช็ค" />
        </Form.Item>

        <Form.Item
          name="bank_name"
          label="ธนาคาร"
        >
          <Input placeholder="ระบุธนาคาร (ถ้ามี)" />
        </Form.Item>

        <Form.Item
          name="bank_account_no"
          label="เลขที่บัญชี/เลขท้ายบัญชี"
        >
          <Input placeholder="ระบุเลขที่บัญชีที่รับชำระ (ถ้ามี)" />
        </Form.Item>

        <Form.Item
          name="notes"
          label="หมายเหตุ"
        >
          <TextArea rows={3} placeholder="หมายเหตุการชำระเงิน" />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button onClick={onCancel}>
              ยกเลิก
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              บันทึกการชำระ
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

const ReceiptDetail = ({ receipt, isMobile, vatModeOptions }) => {
  if (!receipt) return null;

  // แปลง string เป็น number สำหรับการแสดงผลและคำนวณ
  const itemsWithNumber = receipt.items?.map(item => ({
    ...item,
    quantity: parseFloat(item.quantity),
    unit_price: parseFloat(item.unit_price),
    total_price: parseFloat(item.total_price),
    is_free: Boolean(item.is_free)
  })) || [];

  const receiptToShow = {
    ...receipt,
    subtotal: parseFloat(receipt.subtotal || 0),
    discount: parseFloat(receipt.discount || 0),
    tax_amount: parseFloat(receipt.tax_amount || 0),
    total_amount: parseFloat(receipt.total_amount || 0),
    paid_amount: parseFloat(receipt.paid_amount || 0),
    items: itemsWithNumber
  };

  const statusOptions = [
    { value: 'invoice', label: 'ใบแจ้งหนี้', color: 'processing' },
    { value: 'paid', label: 'ชำระแล้ว', color: 'success' },
    { value: 'partial', label: 'ชำระบางส่วน', color: 'warning' },
    { value: 'overdue', label: 'เกินกำหนด', color: 'error' },
    { value: 'cancelled', label: 'ยกเลิก', color: 'default' },
  ];

  const getStatusColor = status => statusOptions.find(opt => opt.value === status)?.color || 'default';
  const getStatusLabel = status => statusOptions.find(opt => opt.value === status)?.label || status;
  const getVatModeLabel = vatMode => {
    if (!vatMode) return 'ไม่ระบุ';
    if (!vatModeOptions || !Array.isArray(vatModeOptions)) return vatMode;
    return vatModeOptions.find(opt => opt.value === vatMode)?.label || vatMode;
  };

  return (
    <Tabs defaultActiveKey="1">
      {/* ข้อมูลใบเสร็จ */}
      <TabPane tab="ข้อมูลใบเสร็จ" key="1">
        <Descriptions column={isMobile ? 1 : 2} bordered size={isMobile ? "small" : "default"}>
          <Descriptions.Item label="เลขที่ใบแจ้งหนี้" span={isMobile ? 1 : 2}>
            {receiptToShow.invoice_number}
          </Descriptions.Item>
          {receiptToShow.receipt_number && (
            <Descriptions.Item label="เลขที่ใบเสร็จ" span={isMobile ? 1 : 2}>
              {receiptToShow.receipt_number}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="ลูกค้า" span={isMobile ? 1 : 2}>
            <div>
              <div>{receiptToShow.contact_name}</div>
              {receiptToShow.company_name && (
                <div style={{ fontSize: '12px', color: '#666' }}>
                  {receiptToShow.company_name}
                </div>
              )}
            </div>
          </Descriptions.Item>
          <Descriptions.Item label="วันที่">
            {dayjs(receiptToShow.receipt_date).format('DD/MM/YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="กำหนดชำระ">
            {receiptToShow.due_date ? dayjs(receiptToShow.due_date).format('DD/MM/YYYY') : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="สถานะ" span={isMobile ? 1 : 2}>
            <Tag color={getStatusColor(receiptToShow.status)}>
              {getStatusLabel(receiptToShow.status)}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="โหมดการคำนวณภาษี" span={isMobile ? 1 : 2}>
            {receiptToShow.vat_mode && (
              <Tag color={receiptToShow.vat_mode === 'include' ? 'green' :
                receiptToShow.vat_mode === 'exclude' ? 'blue' : 'default'}>
                {getVatModeLabel(receiptToShow.vat_mode)}
              </Tag>
            )}
          </Descriptions.Item>

          <Descriptions.Item label="ยอดรวมก่อนภาษี">
            ฿{receiptToShow.subtotal.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label="ส่วนลด">
            ฿{receiptToShow.discount.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label={`ภาษี (${receiptToShow.tax_rate || 0}%)`}>
            ฿{receiptToShow.tax_amount.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label="ยอดรวมทั้งสิ้น">
            <strong>฿{receiptToShow.total_amount.toLocaleString()}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="ชำระแล้ว">
            <strong style={{ color: '#52c41a' }}>฿{receiptToShow.paid_amount.toLocaleString()}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="คงเหลือ">
            <strong style={{ color: '#cf1322' }}>
              ฿{(receiptToShow.total_amount - receiptToShow.paid_amount).toLocaleString()}
            </strong>
          </Descriptions.Item>
          {receiptToShow.payment_method && (
            <Descriptions.Item label="วิธีการชำระ" span={isMobile ? 1 : 2}>
              {receiptToShow.payment_method}
            </Descriptions.Item>
          )}
          {receiptToShow.notes && (
            <Descriptions.Item label="หมายเหตุ" span={isMobile ? 1 : 2}>
              {receiptToShow.notes}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="ผู้สร้าง">{receiptToShow.created_by_name}</Descriptions.Item>
          <Descriptions.Item label="วันที่สร้าง">
            {dayjs(receiptToShow.created_at).format('DD/MM/YYYY HH:mm')}
          </Descriptions.Item>
        </Descriptions>
      </TabPane>

      {/* รายการสินค้า */}
      <TabPane tab="รายการสินค้า" key="2">
        {receiptToShow.items && receiptToShow.items.length > 0 ? (
          isMobile ? (
            <List
              dataSource={receiptToShow.items}
              renderItem={(item, index) => (
                <Card
                  size="small"
                  style={{ marginBottom: 8 }}
                  title={(
                    <Space>
                      <span>{`รายการที่ ${index + 1}`}</span>
                      {item.is_free && <Tag icon={<GiftOutlined />} color="success">ของแถมฟรี</Tag>}
                    </Space>
                  )}
                >
                  <p><strong>รายการ:</strong> {item.description}</p>
                  <Row gutter={16}>
                    <Col span={8}><p><strong>จำนวน:</strong> {item.quantity}</p></Col>
                    <Col span={8}><p><strong>ราคา/หน่วย:</strong> ฿{item.unit_price.toLocaleString()}</p></Col>
                    <Col span={8}>
                      <p><strong>รวม:</strong> {item.is_free ? <Tag color="success">ฟรี</Tag> : `฿${item.total_price.toLocaleString()}`}</p>
                    </Col>
                  </Row>
                </Card>
              )}
            />
          ) : (
            <Table
              dataSource={receiptToShow.items}
              rowKey="id"
              pagination={false}
              columns={[
                { title: 'รายการ', dataIndex: 'description', key: 'description' },
                {
                  title: 'ประเภท', dataIndex: 'is_free', key: 'is_free', align: 'center', width: 120,
                  render: isFree => isFree
                    ? <Tag icon={<GiftOutlined />} color="success">ของแถมฟรี</Tag>
                    : <Tag>คิดเงิน</Tag>
                },
                { title: 'จำนวน', dataIndex: 'quantity', key: 'quantity', align: 'center', width: 100 },
                {
                  title: 'ราคาต่อหน่วย', dataIndex: 'unit_price', key: 'unit_price', align: 'right', width: 120,
                  render: price => `฿${price.toLocaleString()}`
                },
                {
                  title: 'รวม', dataIndex: 'total_price', key: 'total_price', align: 'right', width: 120,
                  render: (total, item) => item.is_free
                    ? <Tag color="success">ฟรี</Tag>
                    : `฿${total.toLocaleString()}`
                }
              ]}
            />
          )
        ) : (
          <Empty description="ไม่มีรายการสินค้า" />
        )}
      </TabPane>
    </Tabs>
  );
};

export default ReceiptsPage;
